/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./node_modules/@shopify/theme-cart/request.js":
/*!*****************************************************!*\
  !*** ./node_modules/@shopify/theme-cart/request.js ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   cart: () => (/* binding */ cart),
/* harmony export */   cartAdd: () => (/* binding */ cartAdd),
/* harmony export */   cartAddFromForm: () => (/* binding */ cartAddFromForm),
/* harmony export */   cartChange: () => (/* binding */ cartChange),
/* harmony export */   cartClear: () => (/* binding */ cartClear),
/* harmony export */   cartShippingRates: () => (/* binding */ cartShippingRates),
/* harmony export */   cartUpdate: () => (/* binding */ cartUpdate)
/* harmony export */ });
function getDefaultRequestConfig() {
  return JSON.parse(
    JSON.stringify({
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json;'
      }
    })
  );
}

function fetchJSON(url, config) {
  return fetch(url, config).then(function(response) {
    if (!response.ok) {
      throw response;
    }
    return response.json();
  });
}

function cart() {
  return fetchJSON('/cart.js', getDefaultRequestConfig());
}

function cartAdd(id, quantity, properties) {
  var config = getDefaultRequestConfig();

  config.method = 'POST';
  config.body = JSON.stringify({
    id: id,
    quantity: quantity,
    properties: properties
  });

  return fetchJSON('/cart/add.js', config);
}

function cartAddFromForm(formData) {
  var config = getDefaultRequestConfig();
  delete config.headers['Content-Type'];

  config.method = 'POST';
  config.body = formData;

  return fetchJSON('/cart/add.js', config);
}

function cartChange(line, options) {
  var config = getDefaultRequestConfig();

  options = options || {};

  config.method = 'POST';
  config.body = JSON.stringify({
    line: line,
    quantity: options.quantity,
    properties: options.properties
  });

  return fetchJSON('/cart/change.js', config);
}

function cartClear() {
  var config = getDefaultRequestConfig();
  config.method = 'POST';

  return fetchJSON('/cart/clear.js', config);
}

function cartUpdate(body) {
  var config = getDefaultRequestConfig();

  config.method = 'POST';
  config.body = JSON.stringify(body);

  return fetchJSON('/cart/update.js', config);
}

function cartShippingRates() {
  return fetchJSON('/cart/shipping_rates.json', getDefaultRequestConfig());
}


/***/ }),

/***/ "./node_modules/@shopify/theme-cart/theme-cart.js":
/*!********************************************************!*\
  !*** ./node_modules/@shopify/theme-cart/theme-cart.js ***!
  \********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   addItem: () => (/* binding */ addItem),
/* harmony export */   addItemFromForm: () => (/* binding */ addItemFromForm),
/* harmony export */   clearAttributes: () => (/* binding */ clearAttributes),
/* harmony export */   clearItems: () => (/* binding */ clearItems),
/* harmony export */   clearNote: () => (/* binding */ clearNote),
/* harmony export */   getAttributes: () => (/* binding */ getAttributes),
/* harmony export */   getItem: () => (/* binding */ getItem),
/* harmony export */   getItemIndex: () => (/* binding */ getItemIndex),
/* harmony export */   getNote: () => (/* binding */ getNote),
/* harmony export */   getShippingRates: () => (/* binding */ getShippingRates),
/* harmony export */   getState: () => (/* binding */ getState),
/* harmony export */   removeItem: () => (/* binding */ removeItem),
/* harmony export */   updateAttributes: () => (/* binding */ updateAttributes),
/* harmony export */   updateItem: () => (/* binding */ updateItem),
/* harmony export */   updateNote: () => (/* binding */ updateNote)
/* harmony export */ });
/* harmony import */ var _request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./request */ "./node_modules/@shopify/theme-cart/request.js");
/* harmony import */ var _validate__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./validate */ "./node_modules/@shopify/theme-cart/validate.js");
/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */




/**
 * Returns the state object of the cart
 * @returns {Promise} Resolves with the state object of the cart (https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#get-cart)
 */
function getState() {
  return _request__WEBPACK_IMPORTED_MODULE_0__.cart();
}

/**
 * Returns the index of the cart line item
 * @param {string} key The unique key of the line item
 * @returns {Promise} Resolves with the index number of the line item
 */
function getItemIndex(key) {
  _validate__WEBPACK_IMPORTED_MODULE_1__.key(key);

  return _request__WEBPACK_IMPORTED_MODULE_0__.cart().then(function(state) {
    var index = -1;

    state.items.forEach(function(item, i) {
      index = item.key === key ? i + 1 : index;
    });

    if (index === -1) {
      return Promise.reject(
        new Error('Theme Cart: Unable to match line item with provided key')
      );
    }

    return index;
  });
}

/**
 * Fetches the line item object
 * @param {string} key The unique key of the line item
 * @returns {Promise} Resolves with the line item object (See response of cart/add.js https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#add-to-cart)
 */
function getItem(key) {
  _validate__WEBPACK_IMPORTED_MODULE_1__.key(key);

  return _request__WEBPACK_IMPORTED_MODULE_0__.cart().then(function(state) {
    var lineItem = null;

    state.items.forEach(function(item) {
      lineItem = item.key === key ? item : lineItem;
    });

    if (lineItem === null) {
      return Promise.reject(
        new Error('Theme Cart: Unable to match line item with provided key')
      );
    }

    return lineItem;
  });
}

/**
 * Add a new line item to the cart
 * @param {number} id The variant's unique ID
 * @param {object} options Optional values to pass to /cart/add.js
 * @param {number} options.quantity The quantity of items to be added to the cart
 * @param {object} options.properties Line item property key/values (https://help.shopify.com/en/themes/liquid/objects/line_item#line_item-properties)
 * @returns {Promise} Resolves with the line item object (See response of cart/add.js https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#add-to-cart)
 */
function addItem(id, options) {
  options = options || {};

  _validate__WEBPACK_IMPORTED_MODULE_1__.id(id);

  return _request__WEBPACK_IMPORTED_MODULE_0__.cartAdd(id, options.quantity, options.properties);
}

/**
 * Add a new line item to the cart from a product form
 * @param {object} form DOM element which is equal to the <form> node
 * @returns {Promise} Resolves with the line item object (See response of cart/add.js https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#add-to-cart)
 */
function addItemFromForm(form) {
  _validate__WEBPACK_IMPORTED_MODULE_1__.form(form);

  var formData = new FormData(form);
  _validate__WEBPACK_IMPORTED_MODULE_1__.id(parseInt(formData.get('id'), 10));

  return _request__WEBPACK_IMPORTED_MODULE_0__.cartAddFromForm(formData);
}

/**
 * Changes the quantity and/or properties of an existing line item.
 * @param {string} key The unique key of the line item (https://help.shopify.com/en/themes/liquid/objects/line_item#line_item-key)
 * @param {object} options Optional values to pass to /cart/add.js
 * @param {number} options.quantity The quantity of items to be added to the cart
 * @param {object} options.properties Line item property key/values (https://help.shopify.com/en/themes/liquid/objects/line_item#line_item-properties)
 * @returns {Promise} Resolves with the state object of the cart (https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#get-cart)
 */
function updateItem(key, options) {
  _validate__WEBPACK_IMPORTED_MODULE_1__.key(key);
  _validate__WEBPACK_IMPORTED_MODULE_1__.options(options);

  return getItemIndex(key).then(function(line) {
    return _request__WEBPACK_IMPORTED_MODULE_0__.cartChange(line, options);
  });
}

/**
 * Removes a line item from the cart
 * @param {string} key The unique key of the line item (https://help.shopify.com/en/themes/liquid/objects/line_item#line_item-key)
 * @returns {Promise} Resolves with the state object of the cart (https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#get-cart)
 */
function removeItem(key) {
  _validate__WEBPACK_IMPORTED_MODULE_1__.key(key);

  return getItemIndex(key).then(function(line) {
    return _request__WEBPACK_IMPORTED_MODULE_0__.cartChange(line, { quantity: 0 });
  });
}

/**
 * Sets all quantities of all line items in the cart to zero. This does not remove cart attributes nor the cart note.
 * @returns {Promise} Resolves with the state object of the cart (https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#get-cart)
 */
function clearItems() {
  return _request__WEBPACK_IMPORTED_MODULE_0__.cartClear();
}

/**
 * Gets all cart attributes
 * @returns {Promise} Resolves with the cart attributes object
 */
function getAttributes() {
  return _request__WEBPACK_IMPORTED_MODULE_0__.cart().then(function(state) {
    return state.attributes;
  });
}

/**
 * Sets all cart attributes
 * @returns {Promise} Resolves with the cart state object
 */
function updateAttributes(attributes) {
  return _request__WEBPACK_IMPORTED_MODULE_0__.cartUpdate({ attributes: attributes });
}

/**
 * Clears all cart attributes
 * @returns {Promise} Resolves with the cart state object
 */
function clearAttributes() {
  return getAttributes().then(function(attributes) {
    for (var key in attributes) {
      attributes[key] = '';
    }
    return updateAttributes(attributes);
  });
}

/**
 * Gets cart note
 * @returns {Promise} Resolves with the cart note string
 */
function getNote() {
  return _request__WEBPACK_IMPORTED_MODULE_0__.cart().then(function(state) {
    return state.note;
  });
}

/**
 * Sets cart note
 * @returns {Promise} Resolves with the cart state object
 */
function updateNote(note) {
  return _request__WEBPACK_IMPORTED_MODULE_0__.cartUpdate({ note: note });
}

/**
 * Clears cart note
 * @returns {Promise} Resolves with the cart state object
 */
function clearNote() {
  return _request__WEBPACK_IMPORTED_MODULE_0__.cartUpdate({ note: '' });
}

/**
 * Get estimated shipping rates.
 * @returns {Promise} Resolves with response of /cart/shipping_rates.json (https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#get-shipping-rates)
 */
function getShippingRates() {
  return _request__WEBPACK_IMPORTED_MODULE_0__.cartShippingRates();
}


/***/ }),

/***/ "./node_modules/@shopify/theme-cart/validate.js":
/*!******************************************************!*\
  !*** ./node_modules/@shopify/theme-cart/validate.js ***!
  \******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   form: () => (/* binding */ form),
/* harmony export */   id: () => (/* binding */ id),
/* harmony export */   key: () => (/* binding */ key),
/* harmony export */   options: () => (/* binding */ options),
/* harmony export */   properties: () => (/* binding */ properties),
/* harmony export */   quantity: () => (/* binding */ quantity)
/* harmony export */ });
function key(key) {
  if (typeof key !== 'string' || key.split(':').length !== 2) {
    throw new TypeError(
      'Theme Cart: Provided key value is not a string with the format xxx:xxx'
    );
  }
}

function quantity(quantity) {
  if (typeof quantity !== 'number' || isNaN(quantity)) {
    throw new TypeError(
      'Theme Cart: An object which specifies a quantity or properties value is required'
    );
  }
}

function id(id) {
  if (typeof id !== 'number' || isNaN(id)) {
    throw new TypeError('Theme Cart: Variant ID must be a number');
  }
}

function properties(properties) {
  if (typeof properties !== 'object') {
    throw new TypeError('Theme Cart: Properties must be an object');
  }
}

function form(form) {
  if (!(form instanceof HTMLFormElement)) {
    throw new TypeError('Theme Cart: Form must be an instance of HTMLFormElement');
  }
}

function options(options) {
  if (typeof options !== 'object') {
    throw new TypeError('Theme Cart: Options must be an object');
  }

  if (
    typeof options.quantity === 'undefined' &&
    typeof options.properties === 'undefined'
  ) {
    throw new Error(
      'Theme Cart: You muse define a value for quantity or properties'
    );
  }

  if (typeof options.quantity !== 'undefined') {
    quantity(options.quantity);
  }

  if (typeof options.properties !== 'undefined') {
    properties(options.properties);
  }
}


/***/ }),

/***/ "./node_modules/@shopify/theme-currency/currency.js":
/*!**********************************************************!*\
  !*** ./node_modules/@shopify/theme-currency/currency.js ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   formatMoney: () => (/* binding */ formatMoney)
/* harmony export */ });
/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

const moneyFormat = '${{amount}}';

/**
 * Format money values based on your shop currency settings
 * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
 * or 3.00 dollars
 * @param  {String} format - shop money_format setting
 * @return {String} value - formatted value
 */
function formatMoney(cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  let value = '';
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || moneyFormat;

  function formatWithDelimiters(
    number,
    precision = 2,
    thousands = ',',
    decimal = '.'
  ) {
    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    const parts = number.split('.');
    const dollarsAmount = parts[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      `$1${thousands}`
    );
    const centsAmount = parts[1] ? decimal + parts[1] : '';

    return dollarsAmount + centsAmount;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
}


/***/ }),

/***/ "./node_modules/@shopify/theme-product-form/listeners.js":
/*!***************************************************************!*\
  !*** ./node_modules/@shopify/theme-product-form/listeners.js ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Listeners)
/* harmony export */ });
function Listeners() {
  this.entries = [];
}

Listeners.prototype.add = function(element, event, fn) {
  this.entries.push({ element: element, event: event, fn: fn });
  element.addEventListener(event, fn);
};

Listeners.prototype.removeAll = function() {
  this.entries = this.entries.filter(function(listener) {
    listener.element.removeEventListener(listener.event, listener.fn);
    return false;
  });
};


/***/ }),

/***/ "./node_modules/@shopify/theme-product-form/theme-product-form.js":
/*!************************************************************************!*\
  !*** ./node_modules/@shopify/theme-product-form/theme-product-form.js ***!
  \************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ProductForm: () => (/* binding */ ProductForm),
/* harmony export */   getUrlWithVariant: () => (/* binding */ getUrlWithVariant)
/* harmony export */ });
/* harmony import */ var _listeners__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./listeners */ "./node_modules/@shopify/theme-product-form/listeners.js");
/* harmony import */ var _shopify_theme_product__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @shopify/theme-product */ "./node_modules/@shopify/theme-product/theme-product.js");



var selectors = {
  idInput: '[name="id"]',
  optionInput: '[name^="options"]',
  quantityInput: '[name="quantity"]',
  propertyInput: '[name^="properties"]'
};

// Public Methods
// -----------------------------------------------------------------------------

/**
 * Returns a URL with a variant ID query parameter. Useful for updating window.history
 * with a new URL based on the currently select product variant.
 * @param {string} url - The URL you wish to append the variant ID to
 * @param {number} id  - The variant ID you wish to append to the URL
 * @returns {string} - The new url which includes the variant ID query parameter
 */

function getUrlWithVariant(url, id) {
  if (/variant=/.test(url)) {
    return url.replace(/(variant=)[^&]+/, '$1' + id);
  } else if (/\?/.test(url)) {
    return url.concat('&variant=').concat(id);
  }

  return url.concat('?variant=').concat(id);
}

/**
 * Constructor class that creates a new instance of a product form controller.
 *
 * @param {Element} element - DOM element which is equal to the <form> node wrapping product form inputs
 * @param {Object} product - A product object
 * @param {Object} options - Optional options object
 * @param {Function} options.onOptionChange - Callback for whenever an option input changes
 * @param {Function} options.onQuantityChange - Callback for whenever an quantity input changes
 * @param {Function} options.onPropertyChange - Callback for whenever a property input changes
 * @param {Function} options.onFormSubmit - Callback for whenever the product form is submitted
 */
function ProductForm(element, product, options) {
  this.element = element;
  this.product = _validateProductObject(product);

  options = options || {};

  this._listeners = new _listeners__WEBPACK_IMPORTED_MODULE_0__["default"]();
  this._listeners.add(
    this.element,
    'submit',
    this._onSubmit.bind(this, options)
  );

  this.optionInputs = this._initInputs(
    selectors.optionInput,
    options.onOptionChange
  );

  this.quantityInputs = this._initInputs(
    selectors.quantityInput,
    options.onQuantityChange
  );

  this.propertyInputs = this._initInputs(
    selectors.propertyInput,
    options.onPropertyChange
  );
}

/**
 * Cleans up all event handlers that were assigned when the Product Form was constructed.
 * Useful for use when a section needs to be reloaded in the theme editor.
 */
ProductForm.prototype.destroy = function() {
  this._listeners.removeAll();
};

/**
 * Getter method which returns the array of currently selected option values
 *
 * @returns {Array} An array of option values
 */
ProductForm.prototype.options = function() {
  return _serializeOptionValues(this.optionInputs, function(item) {
    var regex = /(?:^(options\[))(.*?)(?:\])/;
    item.name = regex.exec(item.name)[2]; // Use just the value between 'options[' and ']'
    return item;
  });
};

/**
 * Getter method which returns the currently selected variant, or `null` if variant
 * doesn't exist.
 *
 * @returns {Object|null} Variant object
 */
ProductForm.prototype.variant = function() {
  return (0,_shopify_theme_product__WEBPACK_IMPORTED_MODULE_1__.getVariantFromSerializedArray)(this.product, this.options());
};

/**
 * Getter method which returns a collection of objects containing name and values
 * of property inputs
 *
 * @returns {Array} Collection of objects with name and value keys
 */
ProductForm.prototype.properties = function() {
  var properties = _serializePropertyValues(this.propertyInputs, function(
    propertyName
  ) {
    var regex = /(?:^(properties\[))(.*?)(?:\])/;
    var name = regex.exec(propertyName)[2]; // Use just the value between 'properties[' and ']'
    return name;
  });

  return Object.entries(properties).length === 0 ? null : properties;
};

/**
 * Getter method which returns the current quantity or 1 if no quantity input is
 * included in the form
 *
 * @returns {Array} Collection of objects with name and value keys
 */
ProductForm.prototype.quantity = function() {
  return this.quantityInputs[0]
    ? Number.parseInt(this.quantityInputs[0].value, 10)
    : 1;
};

// Private Methods
// -----------------------------------------------------------------------------
ProductForm.prototype._setIdInputValue = function(value) {
  var idInputElement = this.element.querySelector(selectors.idInput);

  if (!idInputElement) {
    idInputElement = document.createElement('input');
    idInputElement.type = 'hidden';
    idInputElement.name = 'id';
    this.element.appendChild(idInputElement);
  }

  idInputElement.value = value.toString();
};

ProductForm.prototype._onSubmit = function(options, event) {
  event.dataset = this._getProductFormEventData();

  if (event.dataset.variant) {
    this._setIdInputValue(event.dataset.variant.id);
  }

  if (options.onFormSubmit) {
    options.onFormSubmit(event);
  }
};

ProductForm.prototype._onFormEvent = function(cb) {
  if (typeof cb === 'undefined') {
    return Function.prototype;
  }

  return function(event) {
    event.dataset = this._getProductFormEventData();
    cb(event);
  }.bind(this);
};

ProductForm.prototype._initInputs = function(selector, cb) {
  var elements = Array.prototype.slice.call(
    this.element.querySelectorAll(selector)
  );

  return elements.map(
    function(element) {
      this._listeners.add(element, 'change', this._onFormEvent(cb));
      return element;
    }.bind(this)
  );
};

ProductForm.prototype._getProductFormEventData = function() {
  return {
    options: this.options(),
    variant: this.variant(),
    properties: this.properties(),
    quantity: this.quantity()
  };
};

function _serializeOptionValues(inputs, transform) {
  return inputs.reduce(function(options, input) {
    if (
      input.checked || // If input is a checked (means type radio or checkbox)
      (input.type !== 'radio' && input.type !== 'checkbox') // Or if its any other type of input
    ) {
      options.push(transform({ name: input.name, value: input.value }));
    }

    return options;
  }, []);
}

function _serializePropertyValues(inputs, transform) {
  return inputs.reduce(function(properties, input) {
    if (
      input.checked || // If input is a checked (means type radio or checkbox)
      (input.type !== 'radio' && input.type !== 'checkbox') // Or if its any other type of input
    ) {
      properties[transform(input.name)] = input.value;
    }

    return properties;
  }, {});
}

function _validateProductObject(product) {
  if (typeof product !== 'object') {
    throw new TypeError(product + ' is not an object.');
  }

  if (typeof product.variants[0].options === 'undefined') {
    throw new TypeError(
      'Product object is invalid. Make sure you use the product object that is output from {{ product | json }} or from the http://[your-product-url].js route'
    );
  }

  return product;
}


/***/ }),

/***/ "./node_modules/@shopify/theme-product/theme-product.js":
/*!**************************************************************!*\
  !*** ./node_modules/@shopify/theme-product/theme-product.js ***!
  \**************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   getProductJson: () => (/* binding */ getProductJson),
/* harmony export */   getVariantFromId: () => (/* binding */ getVariantFromId),
/* harmony export */   getVariantFromOptionArray: () => (/* binding */ getVariantFromOptionArray),
/* harmony export */   getVariantFromSerializedArray: () => (/* binding */ getVariantFromSerializedArray)
/* harmony export */ });
/**
 * Returns a product JSON object when passed a product URL
 * @param {*} url
 */
function getProductJson(handle) {
  return fetch('/products/' + handle + '.js').then(function(response) {
    return response.json();
  });
}

/**
 * Find a match in the project JSON (using a ID number) and return the variant (as an Object)
 * @param {Object} product Product JSON object
 * @param {Number} value Accepts Number (e.g. 6908023078973)
 * @returns {Object} The variant object once a match has been successful. Otherwise null will be return
 */
function getVariantFromId(product, value) {
  _validateProductStructure(product);

  if (typeof value !== 'number') {
    throw new TypeError(value + ' is not a Number.');
  }

  var result = product.variants.filter(function(variant) {
    return variant.id === value;
  });

  return result[0] || null;
}

/**
 * Convert the Object (with 'name' and 'value' keys) into an Array of values, then find a match & return the variant (as an Object)
 * @param {Object} product Product JSON object
 * @param {Object} collection Object with 'name' and 'value' keys (e.g. [{ name: "Size", value: "36" }, { name: "Color", value: "Black" }])
 * @returns {Object || null} The variant object once a match has been successful. Otherwise null will be returned
 */
function getVariantFromSerializedArray(product, collection) {
  _validateProductStructure(product);

  // If value is an array of options
  var optionArray = _createOptionArrayFromOptionCollection(product, collection);
  return getVariantFromOptionArray(product, optionArray);
}

/**
 * Find a match in the project JSON (using Array with option values) and return the variant (as an Object)
 * @param {Object} product Product JSON object
 * @param {Array} options List of submitted values (e.g. ['36', 'Black'])
 * @returns {Object || null} The variant object once a match has been successful. Otherwise null will be returned
 */
function getVariantFromOptionArray(product, options) {
  _validateProductStructure(product);
  _validateOptionsArray(options);

  var result = product.variants.filter(function(variant) {
    return options.every(function(option, index) {
      return variant.options[index] === option;
    });
  });

  return result[0] || null;
}

/**
 * Creates an array of selected options from the object
 * Loops through the project.options and check if the "option name" exist (product.options.name) and matches the target
 * @param {Object} product Product JSON object
 * @param {Array} collection Array of object (e.g. [{ name: "Size", value: "36" }, { name: "Color", value: "Black" }])
 * @returns {Array} The result of the matched values. (e.g. ['36', 'Black'])
 */
function _createOptionArrayFromOptionCollection(product, collection) {
  _validateProductStructure(product);
  _validateSerializedArray(collection);

  var optionArray = [];

  collection.forEach(function(option) {
    for (var i = 0; i < product.options.length; i++) {
      if (product.options[i].name.toLowerCase() === option.name.toLowerCase()) {
        optionArray[i] = option.value;
        break;
      }
    }
  });

  return optionArray;
}

/**
 * Check if the product data is a valid JS object
 * Error will be thrown if type is invalid
 * @param {object} product Product JSON object
 */
function _validateProductStructure(product) {
  if (typeof product !== 'object') {
    throw new TypeError(product + ' is not an object.');
  }

  if (Object.keys(product).length === 0 && product.constructor === Object) {
    throw new Error(product + ' is empty.');
  }
}

/**
 * Validate the structure of the array
 * It must be formatted like jQuery's serializeArray()
 * @param {Array} collection Array of object [{ name: "Size", value: "36" }, { name: "Color", value: "Black" }]
 */
function _validateSerializedArray(collection) {
  if (!Array.isArray(collection)) {
    throw new TypeError(collection + ' is not an array.');
  }

  if (collection.length === 0) {
    return [];
  }

  if (collection[0].hasOwnProperty('name')) {
    if (typeof collection[0].name !== 'string') {
      throw new TypeError(
        'Invalid value type passed for name of option ' +
          collection[0].name +
          '. Value should be string.'
      );
    }
  } else {
    throw new Error(collection[0] + 'does not contain name key.');
  }
}

/**
 * Validate the structure of the array
 * It must be formatted as list of values
 * @param {Array} collection Array of object (e.g. ['36', 'Black'])
 */
function _validateOptionsArray(options) {
  if (Array.isArray(options) && typeof options[0] === 'object') {
    throw new Error(options + 'is not a valid array of options.');
  }
}


/***/ }),

/***/ "./node_modules/@shopify/theme-sections/section.js":
/*!*********************************************************!*\
  !*** ./node_modules/@shopify/theme-sections/section.js ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Section)
/* harmony export */ });
var SECTION_ID_ATTR = 'data-section-id';

function Section(container, properties) {
  this.container = validateContainerElement(container);
  this.id = container.getAttribute(SECTION_ID_ATTR);
  this.extensions = [];

  // eslint-disable-next-line es5/no-es6-static-methods
  Object.assign(this, validatePropertiesObject(properties));

  this.onLoad();
}

Section.prototype = {
  onLoad: Function.prototype,
  onUnload: Function.prototype,
  onSelect: Function.prototype,
  onDeselect: Function.prototype,
  onBlockSelect: Function.prototype,
  onBlockDeselect: Function.prototype,

  extend: function extend(extension) {
    this.extensions.push(extension); // Save original extension

    // eslint-disable-next-line es5/no-es6-static-methods
    var extensionClone = Object.assign({}, extension);
    delete extensionClone.init; // Remove init function before assigning extension properties

    // eslint-disable-next-line es5/no-es6-static-methods
    Object.assign(this, extensionClone);

    if (typeof extension.init === 'function') {
      extension.init.apply(this);
    }
  }
};

function validateContainerElement(container) {
  if (!(container instanceof Element)) {
    throw new TypeError(
      'Theme Sections: Attempted to load section. The section container provided is not a DOM element.'
    );
  }
  if (container.getAttribute(SECTION_ID_ATTR) === null) {
    throw new Error(
      'Theme Sections: The section container provided does not have an id assigned to the ' +
        SECTION_ID_ATTR +
        ' attribute.'
    );
  }

  return container;
}

function validatePropertiesObject(value) {
  if (
    (typeof value !== 'undefined' && typeof value !== 'object') ||
    value === null
  ) {
    throw new TypeError(
      'Theme Sections: The properties object provided is not a valid'
    );
  }

  return value;
}

// Object.assign() polyfill from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign#Polyfill
if (typeof Object.assign != 'function') {
  // Must be writable: true, enumerable: false, configurable: true
  Object.defineProperty(Object, 'assign', {
    value: function assign(target) {
      // .length of function is 2
      'use strict';
      if (target == null) {
        // TypeError if undefined or null
        throw new TypeError('Cannot convert undefined or null to object');
      }

      var to = Object(target);

      for (var index = 1; index < arguments.length; index++) {
        var nextSource = arguments[index];

        if (nextSource != null) {
          // Skip over if undefined or null
          for (var nextKey in nextSource) {
            // Avoid bugs when hasOwnProperty is shadowed
            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
      return to;
    },
    writable: true,
    configurable: true
  });
}


/***/ }),

/***/ "./node_modules/@shopify/theme-sections/theme-sections.js":
/*!****************************************************************!*\
  !*** ./node_modules/@shopify/theme-sections/theme-sections.js ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   extend: () => (/* binding */ extend),
/* harmony export */   getInstanceById: () => (/* binding */ getInstanceById),
/* harmony export */   getInstances: () => (/* binding */ getInstances),
/* harmony export */   instances: () => (/* binding */ instances),
/* harmony export */   isInstance: () => (/* binding */ isInstance),
/* harmony export */   load: () => (/* binding */ load),
/* harmony export */   register: () => (/* binding */ register),
/* harmony export */   registered: () => (/* binding */ registered),
/* harmony export */   unload: () => (/* binding */ unload),
/* harmony export */   unregister: () => (/* binding */ unregister)
/* harmony export */ });
/* harmony import */ var _section__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./section */ "./node_modules/@shopify/theme-sections/section.js");
/*
 * @shopify/theme-sections
 * -----------------------------------------------------------------------------
 *
 * A framework to provide structure to your Shopify sections and a load and unload
 * lifecycle. The lifecycle is automatically connected to theme editor events so
 * that your sections load and unload as the editor changes the content and
 * settings of your sections.
 */



var SECTION_TYPE_ATTR = 'data-section-type';
var SECTION_ID_ATTR = 'data-section-id';

window.Shopify = window.Shopify || {};
window.Shopify.theme = window.Shopify.theme || {};
window.Shopify.theme.sections = window.Shopify.theme.sections || {};

var registered = (window.Shopify.theme.sections.registered =
  window.Shopify.theme.sections.registered || {});
var instances = (window.Shopify.theme.sections.instances =
  window.Shopify.theme.sections.instances || []);

function register(type, properties) {
  if (typeof type !== 'string') {
    throw new TypeError(
      'Theme Sections: The first argument for .register must be a string that specifies the type of the section being registered'
    );
  }

  if (typeof registered[type] !== 'undefined') {
    throw new Error(
      'Theme Sections: A section of type "' +
        type +
        '" has already been registered. You cannot register the same section type twice'
    );
  }

  function TypedSection(container) {
    _section__WEBPACK_IMPORTED_MODULE_0__["default"].call(this, container, properties);
  }

  TypedSection.constructor = _section__WEBPACK_IMPORTED_MODULE_0__["default"];
  TypedSection.prototype = Object.create(_section__WEBPACK_IMPORTED_MODULE_0__["default"].prototype);
  TypedSection.prototype.type = type;

  return (registered[type] = TypedSection);
}

function unregister(types) {
  types = normalizeType(types);

  types.forEach(function(type) {
    delete registered[type];
  });
}

function load(types, containers) {
  types = normalizeType(types);

  if (typeof containers === 'undefined') {
    containers = document.querySelectorAll('[' + SECTION_TYPE_ATTR + ']');
  }

  containers = normalizeContainers(containers);

  types.forEach(function(type) {
    var TypedSection = registered[type];

    if (typeof TypedSection === 'undefined') {
      return;
    }

    containers = containers.filter(function(container) {
      // Filter from list of containers because container already has an instance loaded
      if (isInstance(container)) {
        return false;
      }

      // Filter from list of containers because container doesn't have data-section-type attribute
      if (container.getAttribute(SECTION_TYPE_ATTR) === null) {
        return false;
      }

      // Keep in list of containers because current type doesn't match
      if (container.getAttribute(SECTION_TYPE_ATTR) !== type) {
        return true;
      }

      instances.push(new TypedSection(container));

      // Filter from list of containers because container now has an instance loaded
      return false;
    });
  });
}

function unload(selector) {
  var instancesToUnload = getInstances(selector);

  instancesToUnload.forEach(function(instance) {
    var index = instances
      .map(function(e) {
        return e.id;
      })
      .indexOf(instance.id);
    instances.splice(index, 1);
    instance.onUnload();
  });
}

function extend(selector, extension) {
  var instancesToExtend = getInstances(selector);

  instancesToExtend.forEach(function(instance) {
    instance.extend(extension);
  });
}

function getInstances(selector) {
  var filteredInstances = [];

  // Fetch first element if its an array
  if (NodeList.prototype.isPrototypeOf(selector) || Array.isArray(selector)) {
    var firstElement = selector[0];
  }

  // If selector element is DOM element
  if (selector instanceof Element || firstElement instanceof Element) {
    var containers = normalizeContainers(selector);

    containers.forEach(function(container) {
      filteredInstances = filteredInstances.concat(
        instances.filter(function(instance) {
          return instance.container === container;
        })
      );
    });

    // If select is type string
  } else if (typeof selector === 'string' || typeof firstElement === 'string') {
    var types = normalizeType(selector);

    types.forEach(function(type) {
      filteredInstances = filteredInstances.concat(
        instances.filter(function(instance) {
          return instance.type === type;
        })
      );
    });
  }

  return filteredInstances;
}

function getInstanceById(id) {
  var instance;

  for (var i = 0; i < instances.length; i++) {
    if (instances[i].id === id) {
      instance = instances[i];
      break;
    }
  }
  return instance;
}

function isInstance(selector) {
  return getInstances(selector).length > 0;
}

function normalizeType(types) {
  // If '*' then fetch all registered section types
  if (types === '*') {
    types = Object.keys(registered);

    // If a single section type string is passed, put it in an array
  } else if (typeof types === 'string') {
    types = [types];

    // If single section constructor is passed, transform to array with section
    // type string
  } else if (types.constructor === _section__WEBPACK_IMPORTED_MODULE_0__["default"]) {
    types = [types.prototype.type];

    // If array of typed section constructors is passed, transform the array to
    // type strings
  } else if (Array.isArray(types) && types[0].constructor === _section__WEBPACK_IMPORTED_MODULE_0__["default"]) {
    types = types.map(function(TypedSection) {
      return TypedSection.prototype.type;
    });
  }

  types = types.map(function(type) {
    return type.toLowerCase();
  });

  return types;
}

function normalizeContainers(containers) {
  // Nodelist with entries
  if (NodeList.prototype.isPrototypeOf(containers) && containers.length > 0) {
    containers = Array.prototype.slice.call(containers);

    // Empty Nodelist
  } else if (
    NodeList.prototype.isPrototypeOf(containers) &&
    containers.length === 0
  ) {
    containers = [];

    // Handle null (document.querySelector() returns null with no match)
  } else if (containers === null) {
    containers = [];

    // Single DOM element
  } else if (!Array.isArray(containers) && containers instanceof Element) {
    containers = [containers];
  }

  return containers;
}

if (window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', function(event) {
    var id = event.detail.sectionId;
    var container = event.target.querySelector(
      '[' + SECTION_ID_ATTR + '="' + id + '"]'
    );

    if (container !== null) {
      load(container.getAttribute(SECTION_TYPE_ATTR), container);
    }
  });

  document.addEventListener('shopify:section:unload', function(event) {
    var id = event.detail.sectionId;
    var container = event.target.querySelector(
      '[' + SECTION_ID_ATTR + '="' + id + '"]'
    );
    var instance = getInstances(container)[0];

    if (typeof instance === 'object') {
      unload(container);
    }
  });

  document.addEventListener('shopify:section:select', function(event) {
    var instance = getInstanceById(event.detail.sectionId);

    if (typeof instance === 'object') {
      instance.onSelect(event);
    }
  });

  document.addEventListener('shopify:section:deselect', function(event) {
    var instance = getInstanceById(event.detail.sectionId);

    if (typeof instance === 'object') {
      instance.onDeselect(event);
    }
  });

  document.addEventListener('shopify:block:select', function(event) {
    var instance = getInstanceById(event.detail.sectionId);

    if (typeof instance === 'object') {
      instance.onBlockSelect(event);
    }
  });

  document.addEventListener('shopify:block:deselect', function(event) {
    var instance = getInstanceById(event.detail.sectionId);

    if (typeof instance === 'object') {
      instance.onBlockDeselect(event);
    }
  });
}


/***/ }),

/***/ "./src/assets/js/theme.js":
/*!********************************!*\
  !*** ./src/assets/js/theme.js ***!
  \********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var lazysizes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lazysizes */ "./node_modules/lazysizes/lazysizes.js");
/* harmony import */ var lazysizes__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lazysizes__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @shopify/theme-sections */ "./node_modules/@shopify/theme-sections/theme-sections.js");
/* harmony import */ var _shopify_theme_product_form__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @shopify/theme-product-form */ "./node_modules/@shopify/theme-product-form/theme-product-form.js");
/* harmony import */ var _shopify_theme_cart__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @shopify/theme-cart */ "./node_modules/@shopify/theme-cart/theme-cart.js");
/* harmony import */ var _shopify_theme_currency__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @shopify/theme-currency */ "./node_modules/@shopify/theme-currency/currency.js");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }





// import {default as tippy, hideAll} from 'tippy.js';

(lazysizes__WEBPACK_IMPORTED_MODULE_0___default().cfg).loadHidden = false;
Array.prototype.chunk = function (n) {
  if (!this.length) {
    return [];
  }
  return [this.slice(0, n)].concat(this.slice(n).chunk(n));
};
Array.prototype.groupBy = function (props) {
  if (!this.length) {
    return [];
  }
  return this.reduce(function (acc, obj) {
    var key = obj[props];
    if (!acc[key]) {
      acc[key] = [];
    }
    acc[key].push(obj);
    return acc;
  }, {});
};
(function () {
  var bootTheme = function bootTheme() {
    // Some polyfills not provided yet by polyfills.io
    if (window.NodeList && !NodeList.prototype.forEach) {
      NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (var i = 0; i < this.length; i++) {
          callback.call(thisArg, this[i], i, this);
        }
      };
    }
    var _classCallCheck = function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    };
    var _defineProperties = function _defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    };
    var _createClass = function _createClass(Constructor, protoProps, staticProps) {
      if (protoProps) _defineProperties(Constructor.prototype, protoProps);
      if (staticProps) _defineProperties(Constructor, staticProps);
      return Constructor;
    };
    if (window.Handlebars && typeof Handlebars.registerHelper == 'function') {
      Handlebars.registerHelper('validSrc', function (value) {
        return typeof value == 'string' ? value.replace(/\s*/g, '').length !== 0 : false;
      });
    }
    var QuantityPicker = function () {
      function QuantityPicker(element) {
        _classCallCheck(this, QuantityPicker);
        this.element = element ? element : document;
        this.qty_selectors = this.element.querySelectorAll('.qty-picker');
        // this.options = options;
        this._attachListeners();
      }
      _createClass(QuantityPicker, [{
        key: "_attachListeners",
        value: function _attachListeners() {
          var _this = this;
          if (this.qty_selectors && this.qty_selectors.length > 0) {
            this.qty_selectors.forEach(function (el) {
              var button1 = el.querySelector('button.minus');
              var button2 = el.querySelector('button.plus');
              var qty_el = el.querySelector('input');
              button1.addEventListener('click', _this._quantityMinus.bind(_this, qty_el));
              button2.addEventListener('click', _this._quantityPlus.bind(_this, qty_el));
              qty_el.addEventListener('blur', _this._onInputBlur.bind(_this));
            });
          }
        }
      }, {
        key: "_quantityMinus",
        value: function _quantityMinus(qty_el) {
          var min = qty_el.getAttribute('data-min') * 1;
          var num = qty_el.value * 1;
          if (isNaN(num)) {
            num = min;
          }
          qty_el.value = num - 1 < min ? min : num - 1;
          qty_el.dispatchEvent(new Event("change"));
        }
      }, {
        key: "_quantityPlus",
        value: function _quantityPlus(qty_el) {
          var num = qty_el.value * 1;
          var max = qty_el.dataset.max * 1;
          if (isNaN(num)) {
            num = 0;
          }
          if (!isNaN(max) && max != 0 && num >= max) {
            num = max - 1;
          }
          qty_el.value = num + 1;
          qty_el.dispatchEvent(new Event("change"));
        }
      }, {
        key: "_onInputBlur",
        value: function _onInputBlur(e) {
          var min = e.target.getAttribute('data-min') * 1;
          var default_value = e.target.getAttribute('data-default') * 1;
          if (isNaN(e.target.value)) {
            e.target.value = default_value ? default_value : min;
          }
          ;
        }
      }]);
      return QuantityPicker;
    }();
    new QuantityPicker();
    _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_1__.register('header-section', {
      onLoad: function onLoad() {
        var _this2 = this;
        document.addEventListener('click', this._toggle_menu.bind(this));
        window.addEventListener('scroll', function () {
          this.container.closest('.shopify-section').classList.toggle('stickyHeader', document.documentElement.scrollTop > 350);
        }.bind(this));
        this.container.closest('.shopify-section').classList.toggle('stickyHeader', document.documentElement.scrollTop > 350);
        this.container.querySelectorAll('.search_sec .btn-toggle-search').forEach(function (el) {
          return el.addEventListener('click', _this2._toggleSearch.bind(_this2));
        });
      },
      _toggleSearch: function _toggleSearch() {
        var form = this.container.querySelector('.search_sec .mobile-serach-box');
        form && form.classList.toggle('show__search');
      },
      _toggle_menu: function _toggle_menu(event) {
        var target = event.target;
        if (target.classList.contains('has-dropdown') && target.parentElement.classList.contains('show')) {
          this.dropdown_link = this.container.querySelectorAll('a.has-dropdown');
          this.dropdown_link.forEach(function (el) {
            return el.parentElement.classList.remove('show');
          });
          event.preventDefault();
        } else if (target.classList.contains('has-dropdown') && !target.parentElement.classList.contains('show')) {
          this.dropdown_link = this.container.querySelectorAll('a.has-dropdown');
          this.dropdown_link.forEach(function (el) {
            return el.parentElement.classList.remove('show');
          });
          target.parentElement.classList.toggle('show');
        } else {
          this.dropdown_link = this.container.querySelectorAll('a.has-dropdown');
          this.dropdown_link.forEach(function (el) {
            return el.parentElement.classList.remove('show');
          });
        }
      }
    });
    _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_1__.register('custom-collections', {
      onLoad: function onLoad() {
        this._setupGallery();
      },
      onUnload: function onUnload() {
        this._destroyGallery();
      },
      _setupGallery: function _setupGallery() {
        this.gallery = new Swiper(this.container.querySelector('.categoryContainer'), {
          spaceBetween: 1,
          slidesPerView: 1,
          observer: true,
          observeParents: true,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
          },
          pagination: {
            el: ".swiper-pagination",
            type: "progressbar"
          },
          breakpoints: {
            640: {
              slidesPerView: 1,
              spaceBetween: 20
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 20
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 30
            },
            1280: {
              slidesPerView: 3,
              spaceBetween: 100
            }
          }
        });
      },
      _destroyGallery: function _destroyGallery() {
        if (this.gallery && typeof this.gallery.destroy == 'function') {
          this.gallery.destroy();
        }
      }
    });
    _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_1__.register('featured-collections', {
      onLoad: function onLoad() {
        this._setupGallery();
      },
      onUnload: function onUnload() {
        this._destroyGallery();
      },
      _setupGallery: function _setupGallery() {
        this.gallery = new Swiper(this.container.querySelector('.favoriteProduct'), {
          slidesPerView: 1,
          spaceBetween: 30,
          pagination: false,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
          },
          breakpoints: {
            100: {
              autoHeight: true
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 20,
              autoHeight: false
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 50,
              autoHeight: false
            },
            1280: {
              slidesPerView: 4,
              spaceBetween: 65,
              autoHeight: false
            }
          }
        });
      },
      _destroyGallery: function _destroyGallery() {
        if (this.gallery && typeof this.gallery.destroy == 'function') {
          this.gallery.destroy();
        }
      }
    });
    _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_1__.register('testimonials-section', {
      onLoad: function onLoad() {
        this._setupGallery();
      },
      onUnload: function onUnload() {
        this._destroyGallery();
      },
      _setupGallery: function _setupGallery() {
        this.gallery = new Swiper(this.container.querySelector('.testimonialContainer'), {
          observer: true,
          autoHeight: true,
          observeParents: true,
          pagination: {
            el: ".swiper-pagination",
            clickable: true
          }
        });
      },
      _destroyGallery: function _destroyGallery() {
        if (this.gallery && typeof this.gallery.destroy == 'function') {
          this.gallery.destroy();
        }
      }
    });
    _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_1__.register('how-it-works', {
      onLoad: function onLoad() {
        var _this3 = this;
        this._setupGallery();
        this.btn_tabs = this.container.querySelectorAll('.text-tabs > ul a');
        this.tab_items = this.container.querySelectorAll('.text-tabs > .tab-content .tab-item');
        this.btn_tabs.forEach(function (el) {
          return el.addEventListener('click', _this3._toggle_tabs.bind(_this3));
        });
      },
      onUnload: function onUnload() {
        this._destroyGallery();
      },
      _toggle_tabs: function _toggle_tabs(event) {
        event.preventDefault();
        var target = event.currentTarget;
        this.btn_tabs.forEach(function (el) {
          return el.parentElement.classList.remove('active');
        });
        this.tab_items.forEach(function (el) {
          return el.style.display = 'none';
        });
        target.parentElement.classList.add('active');
        var selector = "#".concat(target.dataset.target);
        try {
          this.container.querySelector(selector).classList.add('active');
          this.container.querySelector(selector).style.display = 'block';
        } catch (error) {}
      },
      _setupGallery: function _setupGallery() {
        this.gallery = new Swiper(this.container.querySelector('.tabSlider'), {
          slidesPerView: 1,
          pagination: {
            el: ".swiper-pagination",
            clickable: true
          }
        });
      },
      _destroyGallery: function _destroyGallery() {
        if (this.gallery && typeof this.gallery.destroy == 'function') {
          this.gallery.destroy();
        }
      }
    });
    _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_1__.register('instagram-section', {
      onLoad: function onLoad() {
        this.options = JSON.parse(this.container.getAttribute('data-options') || '{}');
        if (this.options && this.options.instagram) {
          var timer = setInterval(function () {
            if (typeof InstagramFeed == 'function') {
              clearInterval(timer);
              this._setupInstagram();
            }
          }.bind(this), 1);
        }
      },
      onUnload: function onUnload() {
        if (this.slider && typeof this.slider.destroy == 'function') {
          this.slider.destroy();
        }
      },
      _setupInstagram: function _setupInstagram() {
        var self = this;
        new InstagramFeed({
          'username': this.options.instagram,
          'callback': function callback(data) {
            var imgs = (data.edge_owner_to_timeline_media || data.edge_hashtag_to_media || data.edge_location_to_media).edges;
            var html = '';
            if (imgs && imgs.length > 0) {
              var image;
              imgs.forEach(function (img) {
                var url = "https://www.instagram.com/p/" + img.node.shortcode;
                switch (img.node.__typename) {
                  case "GraphSidecar":
                    // type_resource = "sidecar"
                    image = img.node.thumbnail_resources[4].src;
                    break;
                  case "GraphVideo":
                    // type_resource = "video";
                    image = img.node.thumbnail_src;
                    break;
                  default:
                    // type_resource = "image";
                    image = img.node.thumbnail_resources[4].src;
                }
                html += '<div class="swiper-slide"><div class="insta-item relative rounded-2xl group "><a href="' + url + '" target="_blank" rel="noopener noreferrer" class="insta-item-hoverr"><i class="fa fa-instagram"></i><img class="w-full object-cover lazyload" data-src="https://instaproxy.ydm.workers.dev/' + image + '" alt=""></a></div></div>';
              });
            }
            if (html != '') {
              self.container.querySelector('.instagram-slider .swiper-container .swiper-wrapper').innerHTML = html;
              var pagi = self.container.querySelector('.swiper-pagination');
              var options = {
                slidesPerView: 2,
                spaceBetween: 10,
                centeredSlides: true,
                loop: true,
                pagination: false,
                navigation: {
                  nextEl: ".swiper-button-next",
                  prevEl: ".swiper-button-prev"
                },
                breakpoints: {
                  640: {
                    slidesPerView: 2,
                    spaceBetween: 20
                  },
                  1024: {
                    slidesPerView: 3,
                    spaceBetween: 50
                  },
                  1280: {
                    slidesPerView: 4,
                    spaceBetween: 50
                  }
                }
              };
              if (pagi) {
                options.pagination = {
                  el: pagi,
                  clickable: true
                };
              }
              if (self.slider && typeof self.slider.destroy == 'function') {
                self.slider.destroy();
              }
              self.slider = new Swiper(self.container.querySelector('.instagram-slider .swiper-container'), options);
            }
          }
        });
      }
    });
    var size_chart_extension = {
      _save_create_new: function _save_create_new(event) {
        var _this4 = this;
        var btn = event.currentTarget;
        var payload = this._getProfileInputs();
        if (!payload) {
          return;
        }
        btn.disabled = true;
        btn.querySelector('span').innerHTML = 'Saving...';
        this.container.querySelector('.edit-profile').classList.add('hidden');
        this.container.querySelector('.btn-cancel-new').classList.add('hidden');
        this.container.querySelector('[name="profile-name"]').disabled = true;
        var api_endpoint = "".concat(this.api.url, '/profiles/', this.customerId);
        var fetchObj = {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'x-api-key': this.api.key
          },
          body: JSON.stringify(payload)
        };
        if (!isNaN(parseInt(btn.dataset.edit))) {
          api_endpoint = "".concat(this.api.url, '/profiles/', this.customerId, '/', btn.dataset.edit);
          fetchObj.method = 'PATCH';
        }
        fetch(api_endpoint, fetchObj).then(function (response) {
          return response.json();
        }).then(function (profiles) {
          if (profiles.status == 'ok') {
            _this4._setupProfiles(payload);
          }
        });
      },
      _toggle_create_new: function _toggle_create_new(event) {
        var btn = event.currentTarget;
        var is_create = btn.classList.contains('btn-create-new');
        this.container.querySelector('.btn-save-new').dataset.edit = false;
        this.container.querySelector('.create-profile').classList.toggle('hidden', is_create || this.profiles.length != 0);
        this.container.querySelector('.create-new-profile').classList.toggle('hidden', !is_create);
        this.container.querySelector('.existing-profile').classList.toggle('hidden', is_create);
        this.container.querySelector('.existing-profile-table').classList.toggle('hidden', is_create);
        this.container.querySelector('.btn-cancel-new').classList.toggle('hidden', !is_create);
        this.container.querySelector('.edit-profile').classList.toggle('hidden', !is_create);
        this.container.querySelector('[name="profile-name"]').disabled = false;
        this.container.querySelector('.btn-save-new').disabled = false;
        this.container.querySelector('.btn-save-new span').innerHTML = 'Save';
        this.container.querySelectorAll('.size-chart-table-single .size-chart-table td.active').forEach(function (td) {
          td.classList.remove('active');
          td.classList.remove('bg-purple');
          td.classList.remove('text-white');
        });
        this._newMeasurements && this._newMeasurements();
        !is_create && this.container.querySelector('.profile-select').dispatchEvent(new Event('change'));
        this.new_profile = true;
      },
      _setupProfileInputs: function _setupProfileInputs(measurements) {
        var edit_profile_El = this.container.querySelector('.edit-profile');
        if (edit_profile_El) {
          if (!this.edit_profile_source) {
            this.edit_profile_source = edit_profile_El.innerHTML;
          }
          var template = Handlebars.compile(this.edit_profile_source);
          edit_profile_El.innerHTML = template({
            measurements: measurements
          });
        }
      },
      _getProfileInputs: function _getProfileInputs() {
        var btn_edit_profile = this.container.querySelector('.btn-edit-profile');
        var btn_btn_save_new = this.container.querySelector('.btn-save-new');
        var profile_name = this.container.querySelector('[name="profile-name"]');
        var imperial_inputs = this.container.querySelectorAll('[name^="imperial-inputs"]');
        var metric_inputs = this.container.querySelectorAll('[name^="metric-inputs"]');
        var profile = false;
        var inputs = {};
        var size_chart_raw_data = {};
        if (!isNaN(btn_btn_save_new.dataset.edit)) {
          profile = JSON.parse(btn_edit_profile.dataset.profile);
          size_chart_raw_data = JSON.parse(profile.size_chart_raw_data);
        }
        size_chart_raw_data.metric = size_chart_raw_data.metric || [];
        size_chart_raw_data.imperial = size_chart_raw_data.imperial || [];
        metric_inputs.forEach(function (el) {
          var size = size_chart_raw_data.metric.find(function (sz) {
            return sz.label.toLowerCase() == el.dataset.label.toLowerCase();
          });
          if (size) {
            size.value = el.value;
          } else {
            size_chart_raw_data.metric.push({
              value: el.value,
              label: el.dataset.label
            });
          }
        });
        imperial_inputs.forEach(function (el) {
          var size = size_chart_raw_data.imperial.find(function (sz) {
            return sz.label.toLowerCase() == el.dataset.label.toLowerCase();
          });
          if (size) {
            size.value = el.value;
          } else {
            size_chart_raw_data.imperial.push({
              value: el.value,
              label: el.dataset.label
            });
          }
        });
        // imperial_inputs.forEach(el => size_chart_raw_data.imperial.push({ value: el.value, label: el.dataset.label}) );
        // console.log(size_chart_raw_data);
        inputs.name = profile_name.value;
        inputs.size_chart_raw_data = JSON.stringify(size_chart_raw_data);
        profile_name.value = '';
        imperial_inputs.forEach(function (el) {
          return el.value = '';
        });
        metric_inputs.forEach(function (el) {
          return el.value = '';
        });
        // console.log(inputs);
        // return false;
        return inputs;
      },
      _setProfileInputs: function _setProfileInputs(data) {
        var profile_name = this.container.querySelector('[name="profile-name"]');
        var imperial_inputs = this.container.querySelectorAll('[name^="imperial-inputs"]');
        var metric_inputs = this.container.querySelectorAll('[name^="metric-inputs"]');
        // console.log(data)
        if (!data) {
          profile_name.value = '';
          imperial_inputs.forEach(function (el) {
            return el.value = '';
          });
          metric_inputs.forEach(function (el) {
            return el.value = '';
          });
        } else {
          try {
            profile_name.value = data.name;
            imperial_inputs.forEach(function (el, i) {
              var size = data.imperial.find(function (sz) {
                return sz.label.toLowerCase() == el.dataset.label.toLowerCase();
              });
              if (size) {
                el.value = size.value;
              }
            });
            metric_inputs.forEach(function (el, i) {
              var size = data.metric.find(function (sz) {
                return sz.label.toLowerCase() == el.dataset.label.toLowerCase();
              });
              if (size) {
                el.value = size.value;
              }
            });
            // metric_inputs.forEach((el, i) => data.metric && data.metric[i] && (el.value = data.metric[i].value) );
          } catch (error) {
            console.log(error);
          }
        }
      },
      _setupProfiles: function _setupProfiles(data_profile) {
        var _this5 = this;
        if (this.show_metric == undefined) {
          this.show_metric = true;
        }
        this.inputs = [];
        this.container.querySelector('.btn-save-new').dataset.edit = false;
        var create_profile_EL = this.container.querySelector('.create-profile');
        var exist_profile_EL = this.container.querySelector('.existing-profile');
        var profile_selecte_EL = this.container.querySelector('.profile-select');
        var exist_profile_table_EL = this.container.querySelector('.existing-profile-table');
        this.exist_profile_source = this.container.querySelector('#existing-profile-table-templ').innerHTML;
        exist_profile_table_EL && exist_profile_table_EL.classList.add('hidden');
        profile_selecte_EL && profile_selecte_EL.removeEventListener('change', this._selectProfile.bind(this));
        profile_selecte_EL && profile_selecte_EL.addEventListener('change', this._selectProfile.bind(this));
        this.container.querySelector('.create-new-profile').classList.add('hidden');
        if (this.customerId && create_profile_EL) {
          var fetchObj = {
            method: 'GET',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'x-api-key': this.api.key
            }
          };
          fetch("".concat(this.api.url, '/profiles/', this.customerId), fetchObj).then(function (response) {
            return response.json();
          }).then(function (profiles) {
            if (profiles.status == 'ok') {
              _this5.profiles = profiles.profiles;
              var profile_options = '';
              profiles.profiles.forEach(function (profile) {
                // console.log(profile)
                var selected = '';
                if (data_profile && data_profile.name == profile.name) {
                  selected = ' selected="selected"';
                }
                profile_options += ''.concat('<option', selected, '>', profile.name, '</option>');
              });
              profile_selecte_EL.dataset.profiles = JSON.stringify(profiles.profiles);
              profile_selecte_EL.innerHTML = profile_options;
              if (profiles.profiles.length > 0) {
                exist_profile_EL.classList.remove('hidden');
                create_profile_EL.classList.add('hidden');
              } else {
                if (profiles.profiles.length == 0) {
                  create_profile_EL.classList.remove('hidden');
                  exist_profile_EL.classList.add('hidden');
                } else {
                  create_profile_EL.classList.add('hidden');
                  exist_profile_EL.classList.remove('hidden');
                }
              }
              profile_selecte_EL.dispatchEvent(new Event('change'));
            }
          });
        }
      },
      _selectProfile: function _selectProfile(event) {
        var _this6 = this;
        var name = event.currentTarget.value;
        var profiles = JSON.parse(event.currentTarget.dataset.profiles);
        var measurements = JSON.parse(event.currentTarget.dataset.measurements) || [];
        var validProfile = measurements.length > 0;
        var profile = profiles.find(function (pr) {
          return pr.name == name;
        });
        if (!profile) {
          return;
        }
        var size_chart_raw_data = JSON.parse(profile.size_chart_raw_data);
        var profile_id = profile.id;
        var datasizes = JSON.parse(profile.size_chart_raw_data);
        var sizes = {};
        sizes.metric = [];
        sizes.imperial = [];
        if (measurements.length > 0) {
          measurements.forEach(function (label) {
            var _default = {
              value: '',
              "label": label
            };
            var found = datasizes.metric.find(function (sz) {
              return sz.label == label;
            });
            if (!found) {
              found = _default;
              size_chart_raw_data.metric.push(found);
            }
            sizes.metric.push(found);
            found = datasizes.imperial.find(function (sz) {
              return sz.label == label;
            });
            if (!found) {
              found = _default;
              size_chart_raw_data.imperial.push(found);
            }
            sizes.imperial.push(found);
          });
        }
        profile.size_chart_raw_data = JSON.stringify(size_chart_raw_data);
        // console.log(sizes)
        // console.log(measurements)
        // console.log(datasizes)
        // console.log(sizes, measurements, validProfile);
        var exist_profile_table_EL = this.container.querySelector('.existing-profile-table');
        exist_profile_table_EL.classList.remove('hidden');
        if (this.exist_profile_source) {
          var template = Handlebars.compile(this.exist_profile_source);
          exist_profile_table_EL.innerHTML = template({
            measurements: measurements,
            name: name,
            sizes: sizes,
            profile_id: profile_id,
            profile: JSON.stringify(profile)
          });
          setTimeout(function () {
            _this6._toggleMetric();
          }, 300);
          var btn_delete_profile = this.container.querySelector('.btn-delete-profile');
          btn_delete_profile && btn_delete_profile.addEventListener('click', this._delete_profile.bind(this));
          var btn_edit_profile = this.container.querySelector('.btn-edit-profile');
          btn_edit_profile && btn_edit_profile.addEventListener('click', this._edit_profile.bind(this));
        }
        this.container.querySelectorAll('.size-chart-table-single .size-chart-table td.active').forEach(function (td) {
          td.classList.remove('active');
          td.classList.remove('bg-purple');
          td.classList.remove('text-white');
        });
        var tds = {};
        validProfile && sizes.metric && sizes.metric.forEach(function (size, i) {
          _this6.container.querySelectorAll('.size-chart-table-single .chart-metric .size-chart-table').forEach(function (metric_table, j) {
            metric_table.querySelectorAll('tbody tr').forEach(function (tr, k) {
              tr.querySelectorAll('td').forEach(function (td, l) {
                var num = [td.innerHTML, td.innerHTML];
                if (td.innerHTML.indexOf('-') != -1) {
                  num = td.innerHTML.split('-');
                }
                if (i + 1 == l) {
                  if (_this6.sizeRoundingDown) {
                    if (parseInt(num[0]) <= parseInt(size.value) || parseInt(num[1]) <= parseInt(size.value)) {
                      tds['metric' + j + l] = td;
                    }
                  } else {
                    if (!tds['metric' + j + l] && (parseInt(num[0]) >= parseInt(size.value) || parseInt(num[1]) >= parseInt(size.value))) {
                      tds['metric' + j + l] = td;
                    }
                  }
                }
              });
            });
          });
        });
        validProfile && sizes.imperial && sizes.imperial.forEach(function (size, i) {
          _this6.container.querySelectorAll('.size-chart-table-single .chart-imperial .size-chart-table').forEach(function (imperial_table, j) {
            imperial_table.querySelectorAll('tbody tr').forEach(function (tr, k) {
              tr.querySelectorAll('td').forEach(function (td, l) {
                if (i + 1 == l) {
                  var num = [td.innerHTML, td.innerHTML];
                  if (td.innerHTML.indexOf('-') != -1) {
                    num = td.innerHTML.split('-');
                  }
                  if (_this6.sizeRoundingDown) {
                    if (parseInt(num[0]) <= parseInt(size.value) || parseInt(num[1]) <= parseInt(size.value)) {
                      tds['imperial' + j + l] = td;
                    }
                  } else {
                    if (!tds['imperial' + j + l] && (parseInt(num[0]) >= parseInt(size.value) || parseInt(num[1]) >= parseInt(size.value))) {
                      tds['imperial' + j + l] = td;
                    }
                  }
                }
              });
            });
          });
        });
        Object.keys(tds).forEach(function (item) {
          tds[item].classList.add('active');
          tds[item].classList.add('bg-purple');
          tds[item].classList.add('text-white');
        });
      },
      _edit_profile: function _edit_profile(event) {
        this.new_profile = false;
        var profile = JSON.parse(event.currentTarget.dataset.profile);
        var data = JSON.parse(profile.size_chart_raw_data);
        data.name = profile.name;
        this._setProfileInputs(data);
        this.container.querySelector('.btn-create-new').dispatchEvent(new Event('click'));
        this.container.querySelector('.btn-save-new').dataset.edit = profile.id;
        // if (!this.edit_profile_source) {

        // }

        // var edit_profile = this.container.querySelector('.edit-profile');        
        // edit_profile && edit_profile.classList.remove('hidden');
      },
      _delete_profile: function _delete_profile(event) {
        var _this7 = this;
        var id = event.currentTarget.dataset.target;
        event.currentTarget.querySelector('span').innerHTML = 'Loading';
        event.currentTarget.disabled = true;
        if (id && this.customerId) {
          var fetchObj = {
            method: 'DELETE',
            headers: {
              'x-api-key': this.api.key
            }
          };
          fetch("".concat(this.api.url, '/profiles/', this.customerId, '/', id), fetchObj)["catch"](function (error) {
            console.log(error);
          })["finally"](function () {
            _this7._setupProfiles();
          });
        }
      },
      _toggleMetric: function _toggleMetric() {
        var _this8 = this;
        this.container.querySelectorAll('.chart-metric').forEach(function (el) {
          el.classList.toggle('hidden', !_this8.show_metric);
        });
        this.container.querySelectorAll('.chart-imperial').forEach(function (el) {
          el.classList.toggle('hidden', _this8.show_metric);
        });
      }
    };
    var product_section_settings = {
      onLoad: function onLoad() {
        var _this9 = this;
        this.api = {
          key: window.humbird_app ? window.humbird_app.api_key : '',
          //key2: window.humbird_app ? window.humbird_app.api_key_2 : '',
          url: window.humbird_app ? window.humbird_app.api_url.replace(/\/$/, "") : ''
          //url2: window.humbird_app ? window.humbird_app.api_url_2.replace(/\/$/, "") : '',
        };
        this.productId = this.container.dataset.productId;
        this.customerId = this.container.dataset.customerId;
        this.sizeRoundingDown = this.container.dataset.sizeChartHighlightRoundDown == 'yes';
        this.profiles = [];
        this.size_chart = this.container.querySelector('.size-chart-modal');
        window.languages.btnText = this.container.querySelector('[type="submit"] span').innerHTML;
        this._attachListeners();
        this._initOptions();
        this._setupForm();
        this._setupGallery();
        this._setupImageChart();
        this._setupSizeChart(function () {
          if (_this9.customerId) {
            _this9._setupProfiles();
          }
        });
      },
      _attachListeners: function _attachListeners() {
        var _this10 = this;
        if (this.container.querySelectorAll('.feature-accordion .accordion-title')) {
          this.container.querySelectorAll('.feature-accordion .accordion-title').forEach(function (btn) {
            return btn.addEventListener('click', _this10._toggleAccordionPDP.bind(_this10));
          });
        }
        this.container.querySelectorAll('.size-chart-btn').forEach(function (btn) {
          return btn.addEventListener('click', _this10._toggleSizeChart.bind(_this10));
        });
        this.container.querySelectorAll('.size-chart-close-btn').forEach(function (btn) {
          return btn.addEventListener('click', _this10._toggleSizeChart.bind(_this10));
        });
        this.container.querySelectorAll('.btn-create-new').forEach(function (el) {
          return el.addEventListener('click', _this10._toggle_create_new.bind(_this10));
        });
        this.container.querySelectorAll('.btn-cancel-new').forEach(function (el) {
          return el.addEventListener('click', _this10._toggle_create_new.bind(_this10));
        });
        this.container.querySelectorAll('.btn-save-new').forEach(function (el) {
          return el.addEventListener('click', _this10._save_create_new.bind(_this10));
        });
        this.container.querySelectorAll('.tab-header a').forEach(function (tab) {
          return tab.addEventListener('click', _this10._toggleSizeChartTabs.bind(_this10));
        });
        var btns = this.container.querySelectorAll('.btn-metric-toggle');
        btns.forEach(function (btn) {
          btn.addEventListener('click', function (event) {
            btns.forEach(function (b) {
              return b.classList.remove('active');
            });
            event.currentTarget.classList.add('active');
            this.show_metric = event.currentTarget.dataset.target == 'metric';
            this._toggleMetric();
          }.bind(_this10));
        });
      },
      _initOptions: function _initOptions() {
        var _this11 = this;
        var optionsEl = this.container.querySelector('[data-product-options]');
        if (optionsEl && this.productId) {
          var fetchObj = {
            method: 'GET',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'x-api-key': this.api.key
            }
          };
          fetch("".concat(this.api.url, '/products/', this.productId, '/option_set'), fetchObj).then(function (response) {
            return response.json();
          }).then(function (productOptions) {
            if (productOptions.status == "ok" && productOptions.option_set && window.Handlebars && typeof Handlebars.compile == 'function') {
              _this11._setupOptions(optionsEl, productOptions.option_set.options);
            }
          })["catch"](function (error) {
            console.log(error);
          });
        }
      },
      _setupOptions: function _setupOptions(optionsEl, options) {
        var _this12 = this;
        this.tooltipOpen = null;
        if (_typeof(options) != "object") {
          return;
        }
        options.forEach(function (option) {
          var type = null;
          if (option.type == "Image Swatches") {
            type = 'swatches';
            option.swatches.forEach(function (swatch, i) {
              option.swatches[i].fabric_string = swatch.fabric ? JSON.stringify(swatch.fabric) : '';
            });
          } else if (option.type == "Radio") {
            type = 'radio';
          } else if (option.type == "Dropdown") {
            type = 'dropdown';
          } else if (option.type == "Check Box") {
            type = 'checkbox';
          } else if (option.type == "Long Text") {
            type = 'longtext';
          } else if (option.type == "Short Text") {
            type = 'shorttext';
          }
          // console.log(type, option);
          if (type) {
            option.type = type;
            option.set_id = option.label.replace(/[\. ]/g, '_');
            var option_set = _this12._renderOption(option, type, optionsEl.closest('form'));
            if (optionsEl && option_set) {
              optionsEl.insertAdjacentHTML('beforeend', option_set);
            }
            if (type == 'dropdown') {
              optionsEl.querySelectorAll('select').forEach(function (select) {
                if (select.classList.contains('init')) {
                  return;
                }
                select.addEventListener('change', _this12._onOptionSetChange.bind(_this12));
                select.classList.add('init');
              });
            }
            if (type == 'swatches') {
              optionsEl.querySelectorAll('.input-swatches .swatch').forEach(function (swatch) {
                var label = swatch.querySelector('label');
                var input = swatch.querySelector('input');
                var active = input.checked;
                // this._swatch_tooltip(label, active, input);
                // label.addEventListener('click', function(){
                //   setTimeout(hideAll, 300);
                // })
                if (active) {
                  _this12._show_tooltip(label, true, input);
                }
                label.addEventListener('click', function () {
                  try {
                    var tooltip = document.getElementById(label.dataset.tooltip.concat('-', label.dataset.index));
                    tooltip.classList.remove('mobile-hidden');
                  } catch (error) {
                    console.log(error);
                  }
                  _this12._show_tooltip(label, true, input);
                });
              });
              optionsEl.querySelectorAll('.input-swatches [type="radio"]').forEach(function (radio) {
                if (radio.classList.contains('init')) {
                  return;
                }
                radio.addEventListener('change', _this12._onOptionSetChange.bind(_this12));
                radio.addEventListener('change', _this12._onSwatchChange.bind(_this12));
                radio.classList.add('init');
              });
            }
            if (['radio', 'checkbox'].indexOf(type) != -1) {
              optionsEl.querySelectorAll('.custom-radio [type="radio"],.size-radio [type="radio"],.custom-checkbox [type="checkbox"]').forEach(function (radio) {
                if (radio.classList.contains('init')) {
                  return;
                }
                radio.addEventListener('change', _this12._onOptionSetChange.bind(_this12));
                radio.classList.add('init');
              });
            }
          }
        });
        this._setupOptionPrice();
      },
      _show_tooltip: function _show_tooltip(label, active, input) {
        var option = null;
        var tooltip = null;
        var price = 0;
        var form = input.closest('form');
        var index = label.dataset.index;
        var swatchIndex = label.dataset.swatchIndex;
        try {
          option = JSON.parse(input.dataset.optionSet);
          tooltip = document.getElementById(label.dataset.tooltip.concat('-', index));
        } catch (error) {
          console.log(error);
        }
        if (option && tooltip) {
          if (option.use_percentage) {
            price = form.dataset.currentVariantPrice * option.addon_percent / 100;
          } else {
            price = option.addon_price * 100;
          }
          tooltip.style.setProperty('--tooltip-arrow-left', 5 + 21 * swatchIndex + '%');
          tooltip.querySelector('.swatch-name').innerHTML = option.color_name;
          tooltip.querySelector('.color-pane').innerHTML = '';
          tooltip.querySelector('.color-pane').appendChild(label.cloneNode(true));
          document.querySelectorAll('.'.concat(label.dataset.tooltip.replace('/', '\\/'))).forEach(function (el) {
            return el.classList.add('hidden');
          });
          tooltip.querySelector('.addon_price').innerHTML = _shopify_theme_currency__WEBPACK_IMPORTED_MODULE_4__.formatMoney(price, window.languages.shopMoneyFormat);
          tooltip.classList.remove('hidden');
        }
      },
      _getOptionPrice: function _getOptionPrice(option, variant_price) {
        if (option.use_percentage == true) {
          return variant_price * option.addon_percent / 100;
        }
        return option.addon_price * 1;
      },
      _setupOptionPrice: function _setupOptionPrice() {
        var _this13 = this;
        var optionSet = this.container.querySelector('[data-product-options] select[data-option-set],[data-product-options] [data-option-set]:checked');
        optionSet && optionSet.dispatchEvent(new Event('change'));
        setTimeout(function () {
          if (optionSet) {
            var form = optionSet.closest('form');
            var totalPrice = _shopify_theme_currency__WEBPACK_IMPORTED_MODULE_4__.formatMoney(form.dataset.totalPrice, window.languages.shopMoneyFormat);
            var price_html = '<span class="price price--highlight"><span class="sr-only">Sale price</span><span>'.concat(totalPrice, '</span></span>');
            var price_list = _this13.container.querySelectorAll('.product-item__price-list');
            if (price_list) {
              price_list.forEach(function (el) {
                return el.innerHTML = price_html;
              });
            }
          }
        }, 100);
      },
      _optionSetPriceChange: function _optionSetPriceChange(form) {
        var _this14 = this;
        if (this.priceChange) {
          return;
        }
        this.priceChange = true;
        var variant_price = form.dataset.currentVariantPrice / 100;
        var totalPrice = variant_price;
        this.container.querySelectorAll('[data-product-options] select[data-option-set],[data-product-options] [data-option-set]:checked').forEach(function (option_set) {
          var option = JSON.parse(option_set.dataset.optionSet);
          var optionPrice = _this14._getOptionPrice(option, variant_price);
          if (option_set.nodeName.toLowerCase() == 'select') {
            for (var i = 0; i < option_set.options.length; i++) {
              var option_el = option_set[i];
              var optionSet = JSON.parse(option_el.dataset.option);
              var price = _this14._getOptionPrice(optionSet, variant_price);
              if (!isNaN(price) && price != 0) {
                var price_text = _shopify_theme_currency__WEBPACK_IMPORTED_MODULE_4__.formatMoney(price * 100, window.languages.shopMoneyFormat);
                option_el.innerHTML = optionSet.option_name.concat(' (+', price_text, ')');
                var val = option_el.value.split('|');
                var id = val[1] ? '|'.concat(val[1]) : '';
                option_el.value = optionSet.option_name.concat(' (+', price_text, ')', id);
              }
            }
          } else if (['checkbox', 'radio'].indexOf(option_set.nodeName.toLowerCase()) != -1) {}
          totalPrice += optionPrice;
        });
        form.dataset.totalPrice = parseInt((totalPrice * 100).toFixed(2));
        this._setupOptionPrice();
        this.priceChange = false;
      },
      _onOptionSetChange: function _onOptionSetChange(event) {
        var target = event.currentTarget;
        if (target.nodeName.toLowerCase() == 'select') {
          target.dataset.optionSet = target.options[target.selectedIndex].dataset.option;
        }
        this._optionSetPriceChange(target.closest('form'));
      },
      _onSwatchChange: function _onSwatchChange(event) {
        var fabric = null;
        try {
          fabric = JSON.parse(event.currentTarget.dataset.fabric);
        } catch (error) {}
        var btn_atc = this.container.querySelector('[type="submit"]');
        var soldout = btn_atc.dataset.available !== 'true';
        if (!soldout && fabric) {
          soldout = fabric.limit_in_gram <= fabric.period_in_gram;
        }
        if (soldout) {
          btn_atc.setAttribute('disabled', true);
          btn_atc.querySelector('span').innerHTML = window.languages.productFormSoldOut;
        } else {
          if (window.languages.btnATCdisabled) {
            btn_atc.setAttribute('disabled', true);
          } else {
            btn_atc.removeAttribute('disabled');
          }
          if (window.languages.btnText) {
            btn_atc.querySelector('span').innerHTML = window.languages.btnText;
          }
        }
      },
      _renderOption: function _renderOption(option, type, form) {
        var opt = null;
        var variant_price = form && form.dataset.currentVariantPrice / 100;
        if (type == 'swatches') {
          opt = 'swatches';
        }
        if (['dropdown', 'radio'].indexOf(type) !== -1) {
          opt = 'choices';
          option.default_option = option[opt][0] ? JSON.stringify(option[opt][0]) : '';
        }
        opt && option[opt] && option[opt].forEach(function (swatch, i) {
          if (swatch.use_percentage) {
            if (!swatch.addon_percent) {
              swatch.addon_percent = 0;
            }
          }
          var _swatch = JSON.parse(JSON.stringify(option[opt][i]));
          delete _swatch.image_url;
          option[opt][i].stringify = JSON.stringify(_swatch);
          if (['dropdown', 'radio'].indexOf(type) !== -1) {
            var price_text = null;
            if (swatch.use_percentage && variant_price) {
              var addon_percent = swatch.addon_percent == null ? 0 : swatch.addon_percent;
              var price = variant_price * addon_percent / 100;
              price_text = _shopify_theme_currency__WEBPACK_IMPORTED_MODULE_4__.formatMoney(price * 100, window.languages.shopMoneyFormat);
            } else if (swatch.addon_price != null && !isNaN(swatch.addon_price) && swatch.addon_price != 0) {
              price_text = _shopify_theme_currency__WEBPACK_IMPORTED_MODULE_4__.formatMoney(swatch.addon_price * 100, window.languages.shopMoneyFormat);
            }
            if (price_text) {
              if ('radio' == type) {
                swatch.option_value = swatch.option_name;
              }
              swatch.option_name = swatch.option_name.concat(' (+', price_text, ')');
            }
          }
        });
        if (['checkbox'].indexOf(type) != -1) {
          var choice = option.choice;
          if (!choice.addon_percent && choice.use_percentage) {
            option.choice.addon_percent = 0;
          }
          option.choice.stringify = JSON.stringify(choice);
          var price_text = null;
          if (choice.use_percentage && variant_price) {
            var addon_percent = choice.addon_percent == null ? 0 : choice.addon_percent;
            var price = variant_price * addon_percent / 100;
            price_text = _shopify_theme_currency__WEBPACK_IMPORTED_MODULE_4__.formatMoney(price * 100, window.languages.shopMoneyFormat);
          } else if (choice.addon_price != null && !isNaN(choice.addon_price) && choice.addon_price != 0) {
            price_text = _shopify_theme_currency__WEBPACK_IMPORTED_MODULE_4__.formatMoney(choice.addon_price * 100, window.languages.shopMoneyFormat);
          }
          if (price_text) {
            option.label = option.label.concat(' (+', price_text, ')');
          }
        }
        if (type == 'swatches') {
          var color_swatches = [];
          var fabric_swatches = [];
          var group_fabric = [];
          option.swatches.forEach(function (swatch) {
            if (swatch.fabric && swatch.fabric_id > 0 && swatch.fabric.fabric_type) {
              swatch.fabric_type = swatch.fabric.fabric_type;
              fabric_swatches.push(swatch);
            } else {
              color_swatches.push(swatch);
            }
          });
          fabric_swatches = fabric_swatches.groupBy('fabric_type');
          Object.keys(fabric_swatches).forEach(function (fabric_type) {
            var fab = fabric_swatches[fabric_type].chunk(5);
            group_fabric.push.apply(group_fabric, _toConsumableArray(fab));
          });
          option.swatches = [].concat(group_fabric, _toConsumableArray(color_swatches.chunk(5)));
          var last_label = '';
          option.swatches.forEach(function (swatch_group) {
            if (swatch_group[0].fabric_type) {
              if (last_label != swatch_group[0].fabric_type) {
                last_label = swatch_group[0].fabric_type;
                swatch_group[0].label = last_label;
              }
            } else {
              if (last_label != 'Color Options') {
                last_label = 'Color Options';
                swatch_group[0].label = last_label;
              }
            }
          });
        }
        var source = document.querySelector('#input-' + type + '-templ');
        var template = source ? Handlebars.compile(source.innerHTML) : false;
        return template ? template(option) : false;
      },
      /* _swatch_tooltip: function(swatch, show, input) {
        var showOnCreate = show ? true: false;
        return tippy(swatch, {
          content(reference) {
            const id = reference.getAttribute('data-template');
            const template = document.getElementById(id);
            return template.innerHTML;
          },
          onShow(instance) {
            var option = null;
            var price = 0;
            var form = input.closest('form');
            try {
              option = JSON.parse(input.dataset.optionSet);
            } catch (error) {
              
            }
            if (option) {
              if (option.use_percentage) {
                price = form.dataset.currentVariantPrice * option.addon_percent / 100;
              } else {
                price = option.addon_price * 100;
              }
              instance.popper.querySelector('.addon_price').innerHTML = Currency.formatMoney(price, window.languages.shopMoneyFormat );              
            }
          },
          onHide(instance) {
            var swatch = instance.reference.closest('.swatch');
            var active = false;
            if (swatch) {
              active = swatch.querySelector('[type="radio"]').checked;
            }
            if ( active ) {
              return false;
            }
          },
          theme: 'light',
          allowHTML: true,
          trigger: 'mouseenter click',
          showOnCreate
        });
      }, */
      _setupForm: function _setupForm() {
        var _this15 = this;
        var formElement = this.container.querySelector('[data-product-form]');
        var forms = [formElement];
        var productHandle = formElement.dataset.productHandle;
        var selector = '[data-product-handle="'.concat(productHandle, '"]');
        if (productHandle) {
          var url = formElement.dataset.productHandle ? "".concat(formElement.dataset.productHandle, ".js") : "/products/".concat(productHandle, ".js");
          fetch(url).then(function (response) {
            return response.json();
          }).then(function (productJSON) {
            try {
              forms = document.querySelectorAll(selector);
            } catch (error) {}
            forms.forEach(function (formElement) {
              _this15.productForm = new _shopify_theme_product_form__WEBPACK_IMPORTED_MODULE_2__.ProductForm(formElement, productJSON, {
                onOptionChange: _this15._onVariantChange.bind(_this15),
                onFormSubmit: _this15._onFormSubmit.bind(formElement),
                onQuantityChange: function onQuantityChange() {}
              });
            });
          });
        }
      },
      _onFormSubmit: function _onFormSubmit(event) {
        // var form = this;
        // var btn = form.querySelector('[type="submit"]');
        // btn.classList.add('adding-to-cart');
        // btn.disabled = true;
        // event.preventDefault();

        // Cart.addItemFromForm(form)
        //   .then(item => {
        //   })
        //   .catch((error) => {
        //     console.log('A problem occured adding to cart')
        //   })
        //   .finally(()=> {
        //     btn.classList.remove('adding-to-cart');
        //     btn.disabled = false;
        //     window.Shopify.theme.CartDrawer.updateCart(true);
        //   });
      },
      _onVariantChange: function _onVariantChange(event) {
        var variant = event.dataset.variant;
        var btn_atc = this.container.querySelector('[type="submit"]');
        var form = btn_atc.closest('form');
        if (variant) {
          var price = _shopify_theme_currency__WEBPACK_IMPORTED_MODULE_4__.formatMoney(variant.price, window.languages.shopMoneyFormat);
          var compare_price = _shopify_theme_currency__WEBPACK_IMPORTED_MODULE_4__.formatMoney(variant.compare_at_price, window.languages.shopMoneyFormat);
          var price_html = '<span class="price price--highlight"><span class="sr-only">Sale price</span><span>'.concat(price, '</span></span>');
          var compare_price_html = '';
          var price_list = this.container.querySelectorAll('.product-item__price-list');
          if (price_list) {
            if (variant.price < variant.compare_at_price) {
              compare_price_html = '<s class="price price--compare text-gray-300 font-medium ml-2"><span class="sr-only">Regular price</span>'.concat(compare_price, '</s>');
            }
            price_list.forEach(function (el) {
              return el.innerHTML = price_html + compare_price_html;
            });
          }
        }
        btn_atc.dataset.available = variant && variant.available;
        if (variant) {
          form.dataset.currentVariantPrice = variant.price;
        }
        if (variant === null || variant && !variant.available) {
          btn_atc.setAttribute('disabled', true);
          btn_atc.querySelector('span').innerHTML = window.languages.productFormSoldOut;
          window.languages.btnATCdisabled = true;
          window.languages.btnText = window.languages.productFormSoldOut;
        } else if (variant && variant.available) {
          btn_atc.removeAttribute('disabled');
          btn_atc.querySelector('span').innerHTML = window.languages.productFormAddToCart;
          window.languages.btnATCdisabled = false;
          window.languages.btnText = window.languages.productFormAddToCart;
        }
        if (!variant) {
          btn_atc.setAttribute('disabled', true);
          btn_atc.querySelector('span').innerHTML = window.languages.productFormUnavailable;
          window.languages.btnATCdisabled = true;
          window.languages.btnText = window.languages.productFormUnavailable;
          return;
        }

        // this.container.querySelectorAll('.input-swatches [type="radio"]').forEach(radio => {
        //   if (radio.checked) {
        //     radio.dispatchEvent(new Event('change'));
        //   }
        // })
        this._setupOptionPrice();
        var url = _shopify_theme_product_form__WEBPACK_IMPORTED_MODULE_2__.getUrlWithVariant(window.location.href, variant.id);
        window.history.replaceState({
          path: url
        }, '', url);
      },
      _toggleSizeChart: function _toggleSizeChart(event) {
        if (this.size_chart) {
          this.size_chart.classList.toggle('show');
          document.body.classList.toggle('size-chart-open');
          event.preventDefault();
        }
      },
      _toggleAccordionPDP: function _toggleAccordionPDP(event) {
        event.preventDefault();
        var target = event.currentTarget;
        target.closest('.feature-accordion').querySelector('.accordion-body').classList.toggle('hidden');
        target.closest('.feature-accordion').classList.toggle('active');
      },
      _toggleSizeChartTabs: function _toggleSizeChartTabs(event) {
        var tabs = this.container.querySelectorAll('.tab-header a');
        var tab = event.currentTarget;
        var content_selector = tab.getAttribute('href');
        var content_tab = null;
        tabs.forEach(function (tab) {
          return tab.classList.remove('active');
        });
        tab.classList.add('active');
        try {
          content_tab = this.container.querySelector(content_selector);
        } catch (error) {}
        if (content_tab) {
          this.container.querySelectorAll('.tab-body .tab-content').forEach(function (tab) {
            return tab.classList.add('hidden');
          });
          content_tab.classList.remove('hidden');
        }
        event.preventDefault();
      },
      _setupSizeChart: function _setupSizeChart(callback) {
        var _this16 = this;
        var size_chart_table = this.container.querySelector('.size-chart-table-single');
        if (size_chart_table) {
          var fetchObj = {
            method: 'GET',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'x-api-key': this.api.key
            }
          };
          fetch("".concat(this.api.url, '/products/', this.productId, '/size_charts'), fetchObj).then(function (response) {
            return response.json();
          }).then(function (productSizeCharts) {
            if (productSizeCharts.status == 'ok') {
              var source = _this16.container.querySelector('#table-sizecharts-templ');
              var template = Handlebars.compile(source.innerHTML);
              var input_measurements = [];
              var innerHTML = '';
              try {
                productSizeCharts.size_charts.forEach(function (size_chart, index) {
                  var measurements = "Size,".concat(size_chart.measurements).split(',');
                  input_measurements = size_chart.measurements.split(',');
                  var sizes = {};
                  sizes.metric = [];
                  sizes.imperial = [];
                  var raw_data = JSON.parse(size_chart.raw_data);
                  var size_range = size_chart.size_range.split(',');
                  var name = size_chart.name;
                  raw_data.data.forEach(function (j, i) {
                    if (size_range[i]) {
                      sizes.metric.push([size_range[i]].concat(j));
                    }
                  });
                  innerHTML += template({
                    measurements: measurements,
                    sizes: sizes.metric,
                    name: name,
                    "class": 'chart-metric hidden'
                  });
                  raw_data.data_imperial.forEach(function (j, i) {
                    if (size_range[i]) {
                      sizes.imperial.push([size_range[i]].concat(j));
                    }
                  });
                  innerHTML += template({
                    measurements: measurements,
                    sizes: sizes.imperial,
                    name: name,
                    "class": 'chart-imperial'
                  });
                });
              } catch (error) {
                console.log(error);
              }
              _this16.customerId && (_this16.container.querySelector('.profile-select').dataset.measurements = JSON.stringify(input_measurements));
              _this16.customerId && _this16._setupProfileInputs(input_measurements);
              size_chart_table.innerHTML = innerHTML;
              if (typeof callback == 'function') {
                callback();
              }
            }
          });
        }
      },
      _setupImageChart: function _setupImageChart(callback) {
        var image_chart_table = this.container.querySelector('.img-chart-wrapper');
        var product_info = this.container.querySelector('.product-info-wrapper');
        if (image_chart_table) {
          // console.log(this.api.key2, this.api.url2, this.productId);
          var fetchObj = {
            method: 'GET',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'x-api-key': this.api.key
            }
          };
          fetch("".concat(this.api.url, '/products/', this.productId, '/image_charts'), fetchObj).then(function (response) {
            return response.json();
          }).then(function (productSizeImage) {
            //console.log("inject image")
            if (productSizeImage.status == 'ok') {
              var img_url = productSizeImage.image_charts[0].image_url;
              var innerHTML = '<img src="'.concat(img_url, '" class="chart-img" alt="Size Chart">');
              image_chart_table.innerHTML = innerHTML;
              product_info.style.display = 'none';
              if (typeof callback == 'function') {
                callback();
              }
            }
          });
        }
      },
      _setupGallery: function _setupGallery() {
        this.imgThumbnail = new Swiper(this.container.querySelector(".image-thumbnails"), {
          spaceBetween: 10,
          slidesPerView: 4,
          freeMode: true,
          watchSlidesVisibility: true,
          watchSlidesProgress: true,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
          },
          breakpoints: {
            640: {
              slidesPerView: 4,
              spaceBetween: 20
            },
            768: {
              slidesPerView: 4,
              spaceBetween: 30
            }
          }
        });
        // this.imgThumbnail = imgThumbnail;
        this.mainImage = new Swiper(this.container.querySelector(".product-main-image"), {
          spaceBetween: 10,
          autoHeight: true,
          thumbs: {
            swiper: this.imgThumbnail
          }
        });
      },
      _destroyGallery: function _destroyGallery() {
        if (this.imgThumbnail && typeof this.imgThumbnail.destroy == 'function') {
          this.imgThumbnail.destroy();
        }
        if (this.mainImage && typeof this.mainImage.destroy == 'function') {
          this.mainImage.destroy();
        }
      }
    };
    _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_1__.register('product-section', _objectSpread(_objectSpread({}, product_section_settings), size_chart_extension));
    _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_1__.register('event-section', {
      onLoad: function onLoad() {
        var _this17 = this;
        this._setupGallery();
        this.tab_links = this.container.querySelectorAll('.event-link');
        this.tab_links.forEach(function (el) {
          el.addEventListener('click', _this17._toggleFaqPane.bind(_this17));
        });
        setTimeout(function () {
          _this17.tab_links[0] && _this17.tab_links[0].dispatchEvent(new Event('click'));
        }, 300);
      },
      onUnload: function onUnload() {
        // this._destroyGallery();
      },
      _setupGallery: function _setupGallery() {
        this.imgThumbnail = new Swiper(this.container.querySelector(".interlock-history-month-slider"), {
          slidesPerView: 3,
          spaceBetween: 35,
          // loop: true,
          navigation: {
            nextEl: ".interlock-right-arrow",
            prevEl: ".interlock-left-arrow"
          },
          breakpoints: {
            1024: {
              slidesPerView: 3,
              spaceBetween: 35
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 25
            },
            320: {
              slidesPerView: 1,
              spaceBetween: 20
            }
          }
        });
        // this.imgThumbnail = imgThumbnail;
        this.mainImage = new Swiper(this.container.querySelector(".interlock-history-year-slider-container"), {
          slidesPerView: 6,
          breakpoints: {
            740: {
              slidesPerView: 6,
              spaceBetween: 20
            },
            320: {
              slidesPerView: 3,
              spaceBetween: 18
            }
          }
        });
      },
      _destroyGallery: function _destroyGallery() {
        if (this.imgThumbnail && typeof this.imgThumbnail.destroy == 'function') {
          this.imgThumbnail.destroy();
        }
        if (this.mainImage && typeof this.mainImage.destroy == 'function') {
          this.mainImage.destroy();
        }
      },
      _toggleFaqPane: function _toggleFaqPane(event) {
        var target = event.currentTarget;
        var pane = [];
        this.tab_links.forEach(function (el) {
          return el.classList.remove('active');
        });
        this.container.querySelectorAll('.interlock-history-month-box .event').forEach(function (el) {
          return el.classList.add('hidden');
        });
        target.classList.add('active');
        try {
          pane = this.container.querySelectorAll('.interlock-history-month-box .'.concat(target.getAttribute('data-target')));
        } catch (error) {}
        if (pane.length > 0) {
          pane.forEach(function (el) {
            return el.classList.remove('hidden');
          });
          this.imgThumbnail.updateSlides();
          // this.imgThumbnail.init();
        }
        event.preventDefault();
      }
    });
    _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_1__.register('waistbin-section', {
      onLoad: function onLoad() {
        var _this18 = this;
        this._setupGallery();
        this.tab_links = this.container.querySelectorAll('.waitbin-tab');
        this.tab_links.forEach(function (el) {
          el.addEventListener('click', _this18._toggleTabuPane.bind(_this18));
        });
        this.tab_links[0] && this.tab_links[0].dispatchEvent(new Event('click'));
      },
      onUnload: function onUnload() {
        this._destroyGallery();
      },
      _setupGallery: function _setupGallery() {
        this.waistbanSlider = new Swiper(this.container.querySelector(".waistban-right-slider-container"), {
          slidesPerView: 2,
          spaceBetween: 20,
          // loop: true,
          pagination: {
            el: ".swiper-pagination-progressbar",
            type: "progressbar"
          },
          navigation: {
            nextEl: ".waistban-right-arrow",
            prevEl: ".waistban-left-arrow"
          },
          breakpoints: {
            640: {
              slidesPerView: 2,
              spaceBetween: 20
            },
            320: {
              slidesPerView: 1,
              spaceBetween: 20
            }
          }
        });
        // this.waistbanSlider = waistbanSlider;    
      },
      _destroyGallery: function _destroyGallery() {
        if (this.waistbanSlider && typeof this.waistbanSlider.destroy == 'function') {
          this.waistbanSlider.destroy();
        }
      },
      _toggleTabuPane: function _toggleTabuPane(event) {
        event.preventDefault();
        var target = event.currentTarget;
        var pane = [];
        this.tab_links.forEach(function (el) {
          return el.closest('li').classList.remove('active');
        });
        this.container.querySelectorAll('.chart-horizontal-tabs-content .chart-horizontal-tabs-content-item').forEach(function (el) {
          return el.classList.add('hidden');
        });
        target.closest('li').classList.add('active');
        try {
          pane = this.container.querySelectorAll('.chart-horizontal-tabs-content .'.concat(target.getAttribute('data-target')));
        } catch (error) {}
        if (pane.length > 0) {
          pane.forEach(function (el) {
            return el.classList.remove('hidden');
          });
        }
        event.preventDefault();
      }
    });
    _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_1__.register('size-chart-section', {
      onLoad: function onLoad() {
        var _this19 = this;
        this.tab_links = this.container.querySelectorAll('.menu--item');
        this.tab_links.forEach(function (el) {
          el.addEventListener('click', _this19._toggleMenuPane.bind(_this19));
        });
        this.tab_links[0] && this.tab_links[0].dispatchEvent(new Event('click'));
        this.tab_links_2 = this.container.querySelectorAll('.menu--item-2');
        this.tab_links_2.forEach(function (el) {
          el.addEventListener('click', _this19._toggleMenuPane2.bind(_this19));
        });
        this.img_convertor = this.container.querySelectorAll('.image-convertor');
        this.img_convertor.forEach(function (el) {
          el.addEventListener('click', _this19._toggleImage.bind(_this19));
        });
        // this.tab_links_2[0] && this.tab_links_2[0].dispatchEvent(new Event('click') );
      },
      _toggleImage: function _toggleImage(event) {
        event.preventDefault();
        event.stopPropagation();
        var target = event.currentTarget;
        target.closest('.chart--tab-cont').querySelectorAll('.cm-img').forEach(function (el) {
          return el.classList.remove('active');
        });
        target.closest('.chart--tab-cont').querySelectorAll('.image-convertor').forEach(function (el) {
          return el.classList.remove('active');
        });
        target.classList.add('active');
        var img = target.getAttribute('data-target');
        target.closest('.chart--tab-cont').querySelector('.tabele-box .'.concat(target.getAttribute('data-target'))).classList.add('active');
      },
      _toggleMenuPane: function _toggleMenuPane(event) {
        event.preventDefault();
        var target = event.currentTarget;
        var pane = [];
        this.tab_links.forEach(function (el) {
          return el.closest('li').classList.remove('active');
        });
        this.container.querySelectorAll('.content--sec .tab--item').forEach(function (el) {
          return el.classList.add('hidden');
        });
        target.closest('li').classList.add('active');
        try {
          pane = this.container.querySelectorAll('.content--sec .'.concat(target.getAttribute('data-target')));
        } catch (error) {}
        if (pane.length > 0) {
          pane.forEach(function (el) {
            return el.classList.remove('hidden');
          });
        }
        event.preventDefault();
      },
      _toggleMenuPane2: function _toggleMenuPane2(event) {
        var target = event.currentTarget;
        var pane = [];
        target.closest('.tab--item').querySelectorAll('.menu--item-2').forEach(function (el) {
          return el.closest('li').classList.remove('active');
        });
        target.closest('.tab--item').querySelectorAll('.chart--tab-cont').forEach(function (el) {
          return el.classList.add('hidden');
        });
        target.closest('li').classList.add('active');
        try {
          pane = target.closest('.tab--item').querySelectorAll('.'.concat(target.getAttribute('data-target')));
        } catch (error) {}
        if (pane.length > 0) {
          pane.forEach(function (el) {
            return el.classList.remove('hidden');
          });
        }
        event.preventDefault();
      }
    });
    _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_1__.register('cart-section', {
      onLoad: function onLoad() {
        var _this20 = this;
        this.api = {
          key: window.humbird_app ? window.humbird_app.api_key : '',
          url: window.humbird_app ? window.humbird_app.api_url.replace(/\/$/, "") : ''
        };
        this.settings = JSON.parse(this.container.dataset.settings) || {};
        this._cart_updating = false;
        this._updateTimeout = null;
        this.cartTotal = 0;
        this.cartDiscount = 0;
        this.discountCookieName = 'humbird-discount-code';
        this.set_discount = false;
        this.cartPayload = JSON.parse(this.container.dataset.cartPayload);
        this.cart_body = this.container.querySelector('.cart-body');
        if (this.cart_body && this.cartPayload) {
          _shopify_theme_cart__WEBPACK_IMPORTED_MODULE_3__.getState().then(function (state) {
            _this20._setupCart(state);
          });
          this._attachListeners();
        }
      },
      _attachListeners: function _attachListeners() {
        this.container.querySelector('[action="' + window.routes.cart_url + '"]').addEventListener('submit', this._onCartSubmit.bind(this));
        var use_shipping_protection = this.container.querySelector('[name="use_shipping_protection"]');
        if (use_shipping_protection) {
          use_shipping_protection.addEventListener('change', this._toggle_use_shipping_protection.bind(this));
        }
        var note = this.container.querySelector('[name="note"]');
        if (note) {
          note.addEventListener('blur', this._updateNotes.bind(this));
        }
        var btn_discount = this.container.querySelector('.btn-toggle-discount');
        if (btn_discount) {
          btn_discount.addEventListener('click', this._updateDiscount.bind(this));
        }
      },
      _updateDiscount: function _updateDiscount(event) {
        var btn = event.currentTarget;
        var discount = this.container.querySelector('[name="discount"]');
        var code = discount.value.trim();
        if (btn.classList.contains('code-applied')) {
          this._setDiscount('');
          discount.value = '';
        } else if (code != '') {
          this._setDiscount(code);
        }
      },
      _updateNotes: function _updateNotes(event) {
        this.cartPayload.draft_order.note = event.currentTarget.value;
      },
      _toggle_use_shipping_protection: function _toggle_use_shipping_protection(event) {
        var shipping_protection = event.currentTarget;
        var totalEl = this.container.querySelector('.cart-total');
        if (totalEl) {
          var total = parseFloat(totalEl.dataset.total);
          if (shipping_protection.checked) {
            var shipping_protection_price = shipping_protection.value.split('|');
            var fixed = isNaN(shipping_protection_price[0]) ? 0 : shipping_protection_price[0];
            var percentage = isNaN(shipping_protection_price[1]) ? 0 : shipping_protection_price[1];
            total = parseFloat(totalEl.dataset.total) + parseFloat(fixed) + parseFloat(shipping_protection.checked ? totalEl.dataset.total * parseFloat(percentage) / 100 : 0);
          }
          totalEl.querySelector('span').innerHTML = _shopify_theme_currency__WEBPACK_IMPORTED_MODULE_4__.formatMoney(total * 100, window.languages.shopMoneyFormat);
        }
      },
      _qtyChange: function _qtyChange(event) {
        var _this21 = this;
        if (this._cart_updating) {
          return;
        }
        var qty_el = event.currentTarget;
        var cart_item_el = qty_el.closest('.cart-item');
        clearTimeout(this._updateTimeout);
        this._updateTimeout = setTimeout(function () {
          qty_el.disabled = true;
          _this21._cart_updating = true;
          var key = qty_el.dataset.key;
          var quantity = qty_el.value * 1;
          _shopify_theme_cart__WEBPACK_IMPORTED_MODULE_3__.updateItem(key, {
            quantity: quantity
          }).then(function (state) {
            if (_this21.hasDiscountApplied) {
              window.location.href = window.routes.cart_url;
              return state;
            }
            if (quantity < 1) {
              window.location.href = window.routes.cart_url;
            }
            if (cart_item_el) {
              var price = parseFloat(cart_item_el.querySelector('.item-price').dataset.price);
              var line_price = price * quantity;
              cart_item_el.querySelector('.line-price').dataset.price = line_price;
              cart_item_el.querySelector('.line-price').innerHTML = _shopify_theme_currency__WEBPACK_IMPORTED_MODULE_4__.formatMoney(line_price * 100, window.languages.shopMoneyFormat);
            }
            qty_el.closest('form').querySelector('.item-count').innerHTML = state.item_count;
            _this21._updateTotal();
            qty_el.disabled = false;
            _this21._cart_updating = false;
          })["catch"](function (error) {
            console.log(error);
          });
        }, 600);
      },
      _updateTotal: function _updateTotal() {
        var cart_subtotal = this.container.querySelector('.cart-subtotal');
        var cart_total = this.container.querySelector('.cart-total');
        var use_shipping_protection = this.container.querySelector('[name="use_shipping_protection"]');
        var subtotal = 0;
        var total = 0;
        this.cart_body.querySelectorAll('.line-price').forEach(function (line) {
          subtotal += line.dataset.price * 1;
        });
        cart_subtotal.innerHTML = _shopify_theme_currency__WEBPACK_IMPORTED_MODULE_4__.formatMoney(subtotal * 100, window.languages.shopMoneyFormat);
        total = subtotal;
        cart_total.dataset.total = total;
        if (use_shipping_protection) {
          var shipping_protection_price = use_shipping_protection.value.split('|');
          var fixed = isNaN(shipping_protection_price[0]) ? 0 : parseFloat(shipping_protection_price[0]);
          var percentage = isNaN(shipping_protection_price[1]) ? 0 : parseFloat(shipping_protection_price[1]);
          var shipping_protection = fixed + total * percentage / 100;
          this.container.querySelector('.protection_fee').innerHTML = _shopify_theme_currency__WEBPACK_IMPORTED_MODULE_4__.formatMoney(shipping_protection * 100, window.languages.shopMoneyFormat);
        }
        if (use_shipping_protection && use_shipping_protection.checked) {
          total = total + shipping_protection;
        }
        cart_total.querySelector('span').innerHTML = _shopify_theme_currency__WEBPACK_IMPORTED_MODULE_4__.formatMoney(total * 100, window.languages.shopMoneyFormat);
      },
      _onCartSubmit: function _onCartSubmit(event) {
        var _this22 = this;
        var use_shipping_protection = this.container.querySelector('[name="use_shipping_protection"]');
        if (use_shipping_protection) {
          this.cartPayload.draft_order.use_shipping_protection = use_shipping_protection.checked;
        }
        if (this.cartPayload) {
          this._checkoutLock();
          var fetchObj = {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'x-api-key': this.api.key
            },
            body: JSON.stringify(this.cartPayload)
          };
          var url = "".concat(this.api.url, '/draft_orders');
          fetch(url, fetchObj).then(function (response) {
            return response.json();
          }).then(function (cart) {
            if (cart.status == 'ok' && cart.shopify_draft_order.invoice_url) {
              window.location.href = cart.shopify_draft_order.invoice_url;
            }
          })["catch"](function (error) {
            _this22._checkoutLock(false);
          });
        }
        event.preventDefault();
      },
      _setupCart: function _setupCart(state) {
        var _this23 = this;
        this.discountCookieName = ''.concat(this.discountCookieName, state.token);
        this.hasDiscountApplied = false;
        if (this._cart_updating) {
          return;
        }
        this._cart_updating = true;
        var source = this.container.querySelector('#cart-templ');
        source = source.innerHTML.split('<!-- cart-item -->');
        if (this.cartPayload && source) {
          this._setDiscount();
          var use_shipping_protection = this.container.querySelector('[name="use_shipping_protection"]');
          var fetchObj = {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'x-api-key': this.api.key
            },
            body: JSON.stringify(this.cartPayload)
          };
          var url = "".concat(this.api.url, '/draft_orders/calculate_price');
          fetch(url, fetchObj).then(function (response) {
            return response.json();
          }).then(function (cartItems) {
            var total = null;
            var template;
            _this23.cart_body.innerHTML = '';
            cartItems.shopify_draft_order.line_items.forEach(function (line_item) {
              var line_item_html = source.find(function (src) {
                return src.indexOf(line_item.key) != -1;
              });
              if (line_item_html) {
                console.log('lineItem HTML:', line_item_html);
                if (line_item.applied_discount) {
                  _this23.hasDiscountApplied = true;
                  _this23.cartDiscount += +line_item.applied_discount.amount;
                }
                var line_price = line_item.applied_discount && !isNaN(line_item.applied_discount.amount) ? line_item.price - line_item.applied_discount.amount : line_item.price;
                line_item.line_price = _shopify_theme_currency__WEBPACK_IMPORTED_MODULE_4__.formatMoney((line_price * line_item.quantity).toFixed(2), window.languages.shopMoneyFormat);
                line_item.price = _shopify_theme_currency__WEBPACK_IMPORTED_MODULE_4__.formatMoney(line_price.toFixed(2), window.languages.shopMoneyFormat);
                template = Handlebars.compile(line_item_html);
                var cart_item = template(line_item);
                _this23.cart_body.insertAdjacentHTML('beforeend', cart_item);
                _this23.cart_body.querySelector('.cart-item-' + line_item.key).querySelector('.item-price').innerHTML = line_item.price;
                _this23.cart_body.querySelector('.cart-item-' + line_item.key).querySelector('.line-price').innerHTML = line_item.line_price;
                if (isNaN(total)) {
                  total = line_price * line_item.quantity;
                } else {
                  total += line_price * line_item.quantity;
                }
              }
            });
            if (cartItems.shopify_draft_order.applied_discount && !isNaN(cartItems.shopify_draft_order.applied_discount.amount)) {
              total = total - +cartItems.shopify_draft_order.applied_discount.amount;
              _this23.hasDiscountApplied = true;
              _this23.cartDiscount += +cartItems.shopify_draft_order.applied_discount.amount;
            }
            if (!state) {
              _shopify_theme_cart__WEBPACK_IMPORTED_MODULE_3__.getState().then(function (state) {
                _this23._fixCart(state, cartItems);
              });
            } else {
              _this23._fixCart(state, cartItems);
            }
            if (isNaN(total)) {
              window.location.href = window.routes.cart_url;
            }
            var cartDiscountEl = _this23.container.querySelector('.cart-discount');
            if (cartDiscountEl && _this23.cartDiscount > 0) {
              cartDiscountEl.classList.remove('hidden');
              template = Handlebars.compile(cartDiscountEl.innerHTML);
              cartDiscountEl.innerHTML = template({
                discount: _this23.cartDiscount.toFixed(2)
              });
            }
            var subtotalEl = _this23.container.querySelector('.cart-subtotal');
            if (subtotalEl) {
              template = Handlebars.compile(subtotalEl.innerHTML);
              subtotalEl.innerHTML = template({
                subtotal: (_this23.cartDiscount + total).toFixed(2)
              });
              subtotalEl.innerHTML = _shopify_theme_currency__WEBPACK_IMPORTED_MODULE_4__.formatMoney((_this23.cartDiscount + total).toFixed(2), window.languages.shopMoneyFormat);
              subtotalEl.classList.remove('hidden');
              subtotalEl.classList.remove('hidden');
              console.log('Subtotal:', subtotalEl);
            }
            var totalEl = _this23.container.querySelector('.cart-total');
            if (totalEl) {
              template = Handlebars.compile(totalEl.innerHTML);
              totalEl.dataset.total = total;
              if (use_shipping_protection) {
                var shipping_protection_price = use_shipping_protection.value.split('|');
                var fixed = isNaN(shipping_protection_price[0]) ? 0 : parseFloat(shipping_protection_price[0]);
                var percentage = isNaN(shipping_protection_price[1]) ? 0 : parseFloat(shipping_protection_price[1]);
                var shipping_protection = fixed + total * percentage / 100;
                _this23.container.querySelector('.protection_fee').innerHTML = _shopify_theme_currency__WEBPACK_IMPORTED_MODULE_4__.formatMoney(shipping_protection * 100, window.languages.shopMoneyFormat);
              }
              if (use_shipping_protection && use_shipping_protection.checked) {
                total = total + shipping_protection;
              }
              totalEl.innerHTML = template({
                total: total.toFixed(2)
              });
              totalEl.querySelector('span').innerHTML = _shopify_theme_currency__WEBPACK_IMPORTED_MODULE_4__.formatMoney(total * 100, window.languages.shopMoneyFormat);
              totalEl.classList.remove('hidden');
            }
            _this23.container.querySelectorAll('[name^="updates"]').forEach(function (qty_el) {
              qty_el.addEventListener('change', _this23._qtyChange.bind(_this23));
            });
            _this23._cart_updating = false;
          })["catch"](function (error) {
            console.log(error);
            _this23._cart_updating = false;
          })["finally"](function () {
            var discount = _this23.container.querySelector('.discount-code');
            discount && discount.classList.remove('hidden');
          });
        } else {
          this._cart_updating = false;
        }
      },
      _setDiscount: function _setDiscount(code) {
        var btn = this.container.querySelector('.btn-toggle-discount');
        var discountInput = this.container.querySelector('[name="discount"]');
        if (!this.settings.show_discount_input || !btn || !discountInput) {
          return;
        }
        if (typeof code != 'string') {
          if (window.Cookies) {
            code = Cookies.get(this.discountCookieName);
          }
        } else {
          Cookies.set(this.discountCookieName, code, {
            path: '/',
            expires: 30
          });
        }
        this.cartPayload.draft_order.discount_code = typeof code == 'string' ? code : '';
        btn.classList.toggle('code-applied', typeof code == 'string' && ''.concat(code).trim().length > 0);
        if (typeof code == 'string' && ''.concat(code).trim().length > 0) {
          discountInput.setAttribute('readonly', true);
          discountInput.value = code;
        } else {
          discountInput.removeAttribute('readonly');
          discountInput.value = '';
        }
        if (this.set_discount) {
          window.location.href = window.routes.cart_url;
        } else {
          this.set_discount = true;
        }
      },
      _fixCart: function _fixCart(state, cartItems) {
        if (!state || !cartItems) {
          return;
        }
        state.items.forEach(function (item) {
          var line_item = cartItems.shopify_draft_order.line_items.find(function (line_item) {
            return line_item.key == item.key.replace(':', '_');
          });
          if (!line_item) {
            _shopify_theme_cart__WEBPACK_IMPORTED_MODULE_3__.removeItem(item.key).then(function (state) {
              console.log("Invalid item removed in your cart");
              window.location.href = window.routes.cart_url;
              // this.cartPayload.draft_order.line_items = this.cartPayload.draft_order.line_items.filter(lt => lt.key !==item.key.replace(':', '_' ) );
            });
          }
        });
      },
      _checkoutLock: function _checkoutLock(lock) {
        var btn = this.container.querySelector('[type="submit"]');
        btn && (btn.disabled = lock == null ? true : lock);
        btn.innerHTML = btn.disabled ? 'Loading...' : btn.dataset.text;
      }
      // _updateCart: function(cart, callback) {
      //   // this.cartPayload.draft_order.line_items.forEach()
      //   cart.items.forEach(item => {
      //     this.cartPayload.draft_order.line_items.forEach((line_item, index) => {
      //       line_item.quantity = item.quantity;
      //       this.cartPayload.line_items[index] = line_item;
      //     });
      //   });
      //   this.cartPayload.draft_order.line_items.forEach(line_item => {

      //   });
      //   console.log(this.cartPayload, cart);
      //   // this._setupCart();
      //   if (typeof callback == 'function') {
      //     callback();
      //   }
      // }
    });
    _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_1__.register('faq-section', {
      onLoad: function onLoad() {
        var _this24 = this;
        this.tab_links = this.container.querySelectorAll('.tab-link');
        this.accordion_item = this.container.querySelectorAll('.accordion-item');
        this.tab_links.forEach(function (el) {
          el.addEventListener('click', _this24._toggleFaqPane.bind(_this24));
        });
        this.tab_links[0] && this.tab_links[0].dispatchEvent(new Event('click'));
        var menu_toggle = this.container.querySelectorAll('.accordion-title');
        menu_toggle.forEach(function (el) {
          el.addEventListener('click', _this24._toggleFaqaccordion.bind(_this24));
        });
      },
      _toggleFaqPane: function _toggleFaqPane(event) {
        var target = event.currentTarget;
        var pane = [];
        this.tab_links.forEach(function (el) {
          return el.classList.remove('active');
        });
        this.container.querySelectorAll('.tab-content .answer').forEach(function (el) {
          return el.classList.add('hidden');
        });
        target.classList.add('active');
        try {
          pane = this.container.querySelectorAll('.tab-content .'.concat(target.getAttribute('data-target')));
        } catch (error) {}
        if (pane.length > 0) {
          pane.forEach(function (el) {
            return el.classList.remove('hidden');
          });
        }
        event.preventDefault();
      },
      _toggleFaqaccordion: function _toggleFaqaccordion(event) {
        var target = event.currentTarget;
        if (!target) {
          this.accordion_item.forEach(function (el) {
            return el.classList.remove('active');
          });
        }
        target.closest('.accordion-item').classList.toggle('active');
        event.preventDefault();
      }
    });
    _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_1__.register('recommended-product-section', {
      onLoad: function onLoad() {
        var _this25 = this;
        this.tab_links = this.container.querySelectorAll('.tab-link');
        this.accordion_item = this.container.querySelectorAll('.accordion-item');
        this.tab_links.forEach(function (el) {
          el.addEventListener('click', _this25._toggleFaqPane.bind(_this25));
        });
        this.tab_links[0] && this.tab_links[0].dispatchEvent(new Event('click'));
      },
      _toggleFaqPane: function _toggleFaqPane(event) {
        var target = event.currentTarget;
        var pane = [];
        this.tab_links.forEach(function (el) {
          return el.classList.remove('active');
        });
        this.container.querySelectorAll('.tab-content .answer').forEach(function (el) {
          return el.classList.add('hidden');
        });
        target.classList.add('active');
        try {
          pane = this.container.querySelectorAll('.tab-content .'.concat(target.getAttribute('data-target')));
        } catch (error) {}
        if (pane.length > 0) {
          pane.forEach(function (el) {
            return el.classList.remove('hidden');
          });
        }
        event.preventDefault();
      }
    });
    _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_1__.register('collection-template-section', {
      onLoad: function onLoad() {
        this._attach_Event();
      },
      _attach_Event: function _attach_Event() {
        var _this26 = this;
        Shopify.queryParams = {};
        if (location.search.length) {
          var params = location.search.substr(1).split('&');
          for (var i = 0; i < params.length; i++) {
            var keyValue = params[i].split('=');
            if (keyValue.length) {
              Shopify.queryParams[decodeURIComponent(keyValue[0])] = decodeURIComponent(keyValue[1]);
            }
          }
        }
        this.container.querySelector('#sort-by').addEventListener('change', function (e) {
          var value = e.target.value;
          Shopify.queryParams.sort_by = value;
          location.search = new URLSearchParams(Shopify.queryParams).toString();
        });
        this.container.querySelectorAll('h4.text-lg').forEach(function (el) {
          return el.addEventListener('click', function (event) {
            event.preventDefault();
            var filter_div = event.currentTarget;
            filter_div.closest('.filter-part').classList.toggle('close-filter');
          });
        });
        var filterBtn = this.container.querySelector(".filter-btn");
        var filtercloseBtn = this.container.querySelector(".filter-close-btn");
        var filterSection = this.container.querySelector(".filter-section");
        if (filterBtn) {
          filterBtn.onclick = function () {
            filterSection.classList.add("show");
            if (filterSection.classList.contains('show')) {
              document.body.style.overflowY = "hidden";
            } else {
              document.body.style.overflowY = "auto";
            }
          };
        }
        if (filtercloseBtn) {
          filtercloseBtn.onclick = function () {
            filterSection.classList.remove("show");
            if (filterSection.classList.contains('show')) {
              document.body.style.overflowY = "hidden";
            } else {
              document.body.style.overflowY = "auto";
            }
          };
        }
        this.container.querySelectorAll('.filter-section a').forEach(function (el) {
          return el.addEventListener('click', function (event) {
            event.preventDefault();
            var baseUrl = event.target.getAttribute("href");
            if (baseUrl) {
              fetch(baseUrl).then(function (response) {
                return response.text();
              }).then(function (data) {
                var tempDiv = document.createElement("div");
                tempDiv.innerHTML = data;
                var ajax_collection = tempDiv.querySelector('#ajax-catrgories');
                if (ajax_collection) {
                  document.body.style.overflowY = "auto";
                  _this26.container.querySelector('#ajax-catrgories').innerHTML = ajax_collection.innerHTML;
                  if (history.pushState) {
                    history.pushState(null, null, baseUrl);
                  }
                  _this26._attach_Event();
                }
              })["catch"](console.log);
            }
          });
        });
      }
    });
    _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_1__.register('size-profiles-section', _objectSpread(_objectSpread({}, size_chart_extension), {
      onLoad: function onLoad() {
        var _this27 = this;
        this.api = {
          key: window.humbird_app ? window.humbird_app.api_key : '',
          url: window.humbird_app ? window.humbird_app.api_url.replace(/\/$/, "") : ''
        };
        this.customerId = this.container.dataset.customerId;
        this.profiles = [];
        if (this.customerId) {
          this.container.querySelectorAll('.btn-create-new').forEach(function (el) {
            return el.addEventListener('click', _this27._toggle_create_new.bind(_this27));
          });
          this.container.querySelectorAll('.btn-cancel-new').forEach(function (el) {
            return el.addEventListener('click', _this27._toggle_create_new.bind(_this27));
          });
          this.container.querySelectorAll('.btn-save-new').forEach(function (el) {
            return el.addEventListener('click', _this27._save_create_new.bind(_this27));
          });
          // this.container.querySelectorAll('.btn-create-new').forEach(el => el.addEventListener('click', this._newMeasurements.bind(this)) );
          var btns = this.container.querySelectorAll('.btn-metric-toggle');
          btns.forEach(function (btn) {
            btn.addEventListener('click', function (event) {
              btns.forEach(function (b) {
                return b.classList.remove('active');
              });
              event.currentTarget.classList.add('active');
              this.show_metric = event.currentTarget.dataset.target == 'metric';
              this._toggleMetric();
            }.bind(_this27));
          });
          this.new_profile = true;
          this._newMeasurements();
          this._setupProfiles();
        }
      },
      _newMeasurements: function _newMeasurements() {
        if (this.new_profile) {
          var input_measurements = JSON.parse(this.container.dataset.measurements) || [];
          this._setupProfileInputs(input_measurements);
        }
      },
      _selectProfile: function _selectProfile(event) {
        var _this28 = this;
        var name = event.currentTarget.value;
        var profiles = JSON.parse(event.currentTarget.dataset.profiles);
        var measurements = [];
        var profile = profiles.find(function (pr) {
          return pr.name == name;
        });
        if (!profile) {
          return;
        }
        var size_chart_raw_data = JSON.parse(profile.size_chart_raw_data);
        var profile_id = profile.id;
        var datasizes = JSON.parse(profile.size_chart_raw_data);
        var sizes = {};
        sizes.metric = [];
        sizes.imperial = [];
        if (size_chart_raw_data.imperial && size_chart_raw_data.imperial.length) {
          size_chart_raw_data.imperial.forEach(function (sz) {
            measurements.push(sz.label);
          });
        }
        if (measurements.length > 0) {
          this._setupProfileInputs(measurements);
          measurements.forEach(function (label) {
            var _default = {
              value: '',
              "label": label
            };
            var found = datasizes.metric.find(function (sz) {
              return sz.label == label;
            });
            if (!found) {
              found = _default;
              size_chart_raw_data.metric.push(found);
            }
            sizes.metric.push(found);
            found = datasizes.imperial.find(function (sz) {
              return sz.label == label;
            });
            if (!found) {
              found = _default;
              size_chart_raw_data.imperial.push(found);
            }
            sizes.imperial.push(found);
          });
        }
        profile.size_chart_raw_data = JSON.stringify(size_chart_raw_data);
        var exist_profile_table_EL = this.container.querySelector('.existing-profile-table');
        exist_profile_table_EL.classList.remove('hidden');
        if (this.exist_profile_source) {
          var template = Handlebars.compile(this.exist_profile_source);
          exist_profile_table_EL.innerHTML = template({
            measurements: measurements,
            name: name,
            sizes: sizes,
            profile_id: profile_id,
            profile: JSON.stringify(profile)
          });
          setTimeout(function () {
            _this28._toggleMetric();
          }, 300);
          var btn_delete_profile = this.container.querySelector('.btn-delete-profile');
          btn_delete_profile && btn_delete_profile.addEventListener('click', this._delete_profile.bind(this));
          var btn_edit_profile = this.container.querySelector('.btn-edit-profile');
          btn_edit_profile && btn_edit_profile.addEventListener('click', this._edit_profile.bind(this));
        }
      }
    }));
    _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_1__.register('article-template', {
      onLoad: function onLoad() {
        this._setupGallery();
      },
      onUnload: function onUnload() {
        this._destroyGallery();
      },
      _setupGallery: function _setupGallery() {
        this.gallery = new Swiper(this.container.querySelector('.relatedBlog'), {
          slidesPerView: 1,
          spaceBetween: 30,
          pagination: false,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
          },
          breakpoints: {
            768: {
              slidesPerView: 2,
              spaceBetween: 20
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 30
            }
          }
        });
      },
      _destroyGallery: function _destroyGallery() {
        if (this.gallery && typeof this.gallery.destroy == 'function') {
          this.gallery.destroy();
        }
      }
    });
    _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_1__.load('custom-collections', document.querySelectorAll('[data-section-type="custom-collections"]'));
    _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_1__.load('featured-collections', document.querySelectorAll('[data-section-type="featured-collections"]'));
    _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_1__.load('testimonials-section', document.querySelectorAll('[data-section-type="testimonials-section"]'));
    _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_1__.load('how-it-works', document.querySelectorAll('[data-section-type="how-it-works"]'));
    _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_1__.load('instagram-section', document.querySelectorAll('[data-section-type="instagram-section"]'));
    _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_1__.load('header-section', document.querySelector('[data-section-type="header-section"]'));
    _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_1__.load('product-section', document.querySelector('[data-section-type="product-section"]'));
    _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_1__.load('faq-section', document.querySelector('[data-section-type="faq-section"]'));
    _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_1__.load('recommended-product-section', document.querySelector('[data-section-type="recommended-product-section"]'));
    _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_1__.load('collection-template-section', document.querySelector('[data-section-type="collection-template-section"]'));
    _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_1__.load('article-template', document.querySelector('[data-section-type="article-template"]'));
    _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_1__.load('size-profiles-section', document.querySelector('[data-section-type="size-profiles-section"]'));
    _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_1__.load('cart-section', document.querySelector('[data-section-type="cart-section"]'));
    _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_1__.load('size-chart-section', document.querySelector('[data-section-type="size-chart-section"]'));
    _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_1__.load('waistbin-section', document.querySelector('[data-section-type="waistbin-section"]'));
    _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_1__.load('event-section', document.querySelector('[data-section-type="event-section"]'));
    (function () {
      var links = document.links;
      for (var i = 0, linksLength = links.length; i < linksLength; i++) {
        if (links[i].hostname !== "" && links[i].hostname !== window.location.hostname) {
          links[i].target = '_blank';
          links[i].rel = 'noreferrer noopener';
        }
      }
    })();
  };
  var docReady = function docReady(fn) {
    if (document.readyState === "complete" || document.readyState === "interactive") {
      // call on next available tick
      setTimeout(fn, 1);
    } else {
      document.addEventListener("DOMContentLoaded", fn);
    }
  };
  docReady(function () {
    if ('fetch' in window && 'assign' in Object) {
      bootTheme();
    } else {
      var scriptEl = document.createElement('script');
      scriptEl.src = '//cdn.polyfill.io/v3/polyfill.min.js?unknown=polyfill&features=fetch,Element.prototype.closest,Element.prototype.matches,Element.prototype.remove,Element.prototype.classList,Array.prototype.includes,String.prototype.includes,Object.assign,CustomEvent,URL,DOMTokenList';
      scriptEl.async = false;
      scriptEl.onload = function () {
        bootTheme();
      };
      document.head.appendChild(scriptEl);
    }
  });
})();

/***/ }),

/***/ "./node_modules/lazysizes/lazysizes.js":
/*!*********************************************!*\
  !*** ./node_modules/lazysizes/lazysizes.js ***!
  \*********************************************/
/***/ ((module) => {

(function(window, factory) {
	var lazySizes = factory(window, window.document, Date);
	window.lazySizes = lazySizes;
	if( true && module.exports){
		module.exports = lazySizes;
	}
}(typeof window != 'undefined' ?
      window : {}, 
/**
 * import("./types/global")
 * @typedef { import("./types/lazysizes-config").LazySizesConfigPartial } LazySizesConfigPartial
 */
function l(window, document, Date) { // Pass in the window Date function also for SSR because the Date class can be lost
	'use strict';
	/*jshint eqnull:true */

	var lazysizes,
		/**
		 * @type { LazySizesConfigPartial }
		 */
		lazySizesCfg;

	(function(){
		var prop;

		var lazySizesDefaults = {
			lazyClass: 'lazyload',
			loadedClass: 'lazyloaded',
			loadingClass: 'lazyloading',
			preloadClass: 'lazypreload',
			errorClass: 'lazyerror',
			//strictClass: 'lazystrict',
			autosizesClass: 'lazyautosizes',
			fastLoadedClass: 'ls-is-cached',
			iframeLoadMode: 0,
			srcAttr: 'data-src',
			srcsetAttr: 'data-srcset',
			sizesAttr: 'data-sizes',
			//preloadAfterLoad: false,
			minSize: 40,
			customMedia: {},
			init: true,
			expFactor: 1.5,
			hFac: 0.8,
			loadMode: 2,
			loadHidden: true,
			ricTimeout: 0,
			throttleDelay: 125,
		};

		lazySizesCfg = window.lazySizesConfig || window.lazysizesConfig || {};

		for(prop in lazySizesDefaults){
			if(!(prop in lazySizesCfg)){
				lazySizesCfg[prop] = lazySizesDefaults[prop];
			}
		}
	})();

	if (!document || !document.getElementsByClassName) {
		return {
			init: function () {},
			/**
			 * @type { LazySizesConfigPartial }
			 */
			cfg: lazySizesCfg,
			/**
			 * @type { true }
			 */
			noSupport: true,
		};
	}

	var docElem = document.documentElement;

	var supportPicture = window.HTMLPictureElement;

	var _addEventListener = 'addEventListener';

	var _getAttribute = 'getAttribute';

	/**
	 * Update to bind to window because 'this' becomes null during SSR
	 * builds.
	 */
	var addEventListener = window[_addEventListener].bind(window);

	var setTimeout = window.setTimeout;

	var requestAnimationFrame = window.requestAnimationFrame || setTimeout;

	var requestIdleCallback = window.requestIdleCallback;

	var regPicture = /^picture$/i;

	var loadEvents = ['load', 'error', 'lazyincluded', '_lazyloaded'];

	var regClassCache = {};

	var forEach = Array.prototype.forEach;

	/**
	 * @param ele {Element}
	 * @param cls {string}
	 */
	var hasClass = function(ele, cls) {
		if(!regClassCache[cls]){
			regClassCache[cls] = new RegExp('(\\s|^)'+cls+'(\\s|$)');
		}
		return regClassCache[cls].test(ele[_getAttribute]('class') || '') && regClassCache[cls];
	};

	/**
	 * @param ele {Element}
	 * @param cls {string}
	 */
	var addClass = function(ele, cls) {
		if (!hasClass(ele, cls)){
			ele.setAttribute('class', (ele[_getAttribute]('class') || '').trim() + ' ' + cls);
		}
	};

	/**
	 * @param ele {Element}
	 * @param cls {string}
	 */
	var removeClass = function(ele, cls) {
		var reg;
		if ((reg = hasClass(ele,cls))) {
			ele.setAttribute('class', (ele[_getAttribute]('class') || '').replace(reg, ' '));
		}
	};

	var addRemoveLoadEvents = function(dom, fn, add){
		var action = add ? _addEventListener : 'removeEventListener';
		if(add){
			addRemoveLoadEvents(dom, fn);
		}
		loadEvents.forEach(function(evt){
			dom[action](evt, fn);
		});
	};

	/**
	 * @param elem { Element }
	 * @param name { string }
	 * @param detail { any }
	 * @param noBubbles { boolean }
	 * @param noCancelable { boolean }
	 * @returns { CustomEvent }
	 */
	var triggerEvent = function(elem, name, detail, noBubbles, noCancelable){
		var event = document.createEvent('Event');

		if(!detail){
			detail = {};
		}

		detail.instance = lazysizes;

		event.initEvent(name, !noBubbles, !noCancelable);

		event.detail = detail;

		elem.dispatchEvent(event);
		return event;
	};

	var updatePolyfill = function (el, full){
		var polyfill;
		if( !supportPicture && ( polyfill = (window.picturefill || lazySizesCfg.pf) ) ){
			if(full && full.src && !el[_getAttribute]('srcset')){
				el.setAttribute('srcset', full.src);
			}
			polyfill({reevaluate: true, elements: [el]});
		} else if(full && full.src){
			el.src = full.src;
		}
	};

	var getCSS = function (elem, style){
		return (getComputedStyle(elem, null) || {})[style];
	};

	/**
	 *
	 * @param elem { Element }
	 * @param parent { Element }
	 * @param [width] {number}
	 * @returns {number}
	 */
	var getWidth = function(elem, parent, width){
		width = width || elem.offsetWidth;

		while(width < lazySizesCfg.minSize && parent && !elem._lazysizesWidth){
			width =  parent.offsetWidth;
			parent = parent.parentNode;
		}

		return width;
	};

	var rAF = (function(){
		var running, waiting;
		var firstFns = [];
		var secondFns = [];
		var fns = firstFns;

		var run = function(){
			var runFns = fns;

			fns = firstFns.length ? secondFns : firstFns;

			running = true;
			waiting = false;

			while(runFns.length){
				runFns.shift()();
			}

			running = false;
		};

		var rafBatch = function(fn, queue){
			if(running && !queue){
				fn.apply(this, arguments);
			} else {
				fns.push(fn);

				if(!waiting){
					waiting = true;
					(document.hidden ? setTimeout : requestAnimationFrame)(run);
				}
			}
		};

		rafBatch._lsFlush = run;

		return rafBatch;
	})();

	var rAFIt = function(fn, simple){
		return simple ?
			function() {
				rAF(fn);
			} :
			function(){
				var that = this;
				var args = arguments;
				rAF(function(){
					fn.apply(that, args);
				});
			}
		;
	};

	var throttle = function(fn){
		var running;
		var lastTime = 0;
		var gDelay = lazySizesCfg.throttleDelay;
		var rICTimeout = lazySizesCfg.ricTimeout;
		var run = function(){
			running = false;
			lastTime = Date.now();
			fn();
		};
		var idleCallback = requestIdleCallback && rICTimeout > 49 ?
			function(){
				requestIdleCallback(run, {timeout: rICTimeout});

				if(rICTimeout !== lazySizesCfg.ricTimeout){
					rICTimeout = lazySizesCfg.ricTimeout;
				}
			} :
			rAFIt(function(){
				setTimeout(run);
			}, true)
		;

		return function(isPriority){
			var delay;

			if((isPriority = isPriority === true)){
				rICTimeout = 33;
			}

			if(running){
				return;
			}

			running =  true;

			delay = gDelay - (Date.now() - lastTime);

			if(delay < 0){
				delay = 0;
			}

			if(isPriority || delay < 9){
				idleCallback();
			} else {
				setTimeout(idleCallback, delay);
			}
		};
	};

	//based on http://modernjavascript.blogspot.de/2013/08/building-better-debounce.html
	var debounce = function(func) {
		var timeout, timestamp;
		var wait = 99;
		var run = function(){
			timeout = null;
			func();
		};
		var later = function() {
			var last = Date.now() - timestamp;

			if (last < wait) {
				setTimeout(later, wait - last);
			} else {
				(requestIdleCallback || run)(run);
			}
		};

		return function() {
			timestamp = Date.now();

			if (!timeout) {
				timeout = setTimeout(later, wait);
			}
		};
	};

	var loader = (function(){
		var preloadElems, isCompleted, resetPreloadingTimer, loadMode, started;

		var eLvW, elvH, eLtop, eLleft, eLright, eLbottom, isBodyHidden;

		var regImg = /^img$/i;
		var regIframe = /^iframe$/i;

		var supportScroll = ('onscroll' in window) && !(/(gle|ing)bot/.test(navigator.userAgent));

		var shrinkExpand = 0;
		var currentExpand = 0;

		var isLoading = 0;
		var lowRuns = -1;

		var resetPreloading = function(e){
			isLoading--;
			if(!e || isLoading < 0 || !e.target){
				isLoading = 0;
			}
		};

		var isVisible = function (elem) {
			if (isBodyHidden == null) {
				isBodyHidden = getCSS(document.body, 'visibility') == 'hidden';
			}

			return isBodyHidden || !(getCSS(elem.parentNode, 'visibility') == 'hidden' && getCSS(elem, 'visibility') == 'hidden');
		};

		var isNestedVisible = function(elem, elemExpand){
			var outerRect;
			var parent = elem;
			var visible = isVisible(elem);

			eLtop -= elemExpand;
			eLbottom += elemExpand;
			eLleft -= elemExpand;
			eLright += elemExpand;

			while(visible && (parent = parent.offsetParent) && parent != document.body && parent != docElem){
				visible = ((getCSS(parent, 'opacity') || 1) > 0);

				if(visible && getCSS(parent, 'overflow') != 'visible'){
					outerRect = parent.getBoundingClientRect();
					visible = eLright > outerRect.left &&
						eLleft < outerRect.right &&
						eLbottom > outerRect.top - 1 &&
						eLtop < outerRect.bottom + 1
					;
				}
			}

			return visible;
		};

		var checkElements = function() {
			var eLlen, i, rect, autoLoadElem, loadedSomething, elemExpand, elemNegativeExpand, elemExpandVal,
				beforeExpandVal, defaultExpand, preloadExpand, hFac;
			var lazyloadElems = lazysizes.elements;

			if((loadMode = lazySizesCfg.loadMode) && isLoading < 8 && (eLlen = lazyloadElems.length)){

				i = 0;

				lowRuns++;

				for(; i < eLlen; i++){

					if(!lazyloadElems[i] || lazyloadElems[i]._lazyRace){continue;}

					if(!supportScroll || (lazysizes.prematureUnveil && lazysizes.prematureUnveil(lazyloadElems[i]))){unveilElement(lazyloadElems[i]);continue;}

					if(!(elemExpandVal = lazyloadElems[i][_getAttribute]('data-expand')) || !(elemExpand = elemExpandVal * 1)){
						elemExpand = currentExpand;
					}

					if (!defaultExpand) {
						defaultExpand = (!lazySizesCfg.expand || lazySizesCfg.expand < 1) ?
							docElem.clientHeight > 500 && docElem.clientWidth > 500 ? 500 : 370 :
							lazySizesCfg.expand;

						lazysizes._defEx = defaultExpand;

						preloadExpand = defaultExpand * lazySizesCfg.expFactor;
						hFac = lazySizesCfg.hFac;
						isBodyHidden = null;

						if(currentExpand < preloadExpand && isLoading < 1 && lowRuns > 2 && loadMode > 2 && !document.hidden){
							currentExpand = preloadExpand;
							lowRuns = 0;
						} else if(loadMode > 1 && lowRuns > 1 && isLoading < 6){
							currentExpand = defaultExpand;
						} else {
							currentExpand = shrinkExpand;
						}
					}

					if(beforeExpandVal !== elemExpand){
						eLvW = innerWidth + (elemExpand * hFac);
						elvH = innerHeight + elemExpand;
						elemNegativeExpand = elemExpand * -1;
						beforeExpandVal = elemExpand;
					}

					rect = lazyloadElems[i].getBoundingClientRect();

					if ((eLbottom = rect.bottom) >= elemNegativeExpand &&
						(eLtop = rect.top) <= elvH &&
						(eLright = rect.right) >= elemNegativeExpand * hFac &&
						(eLleft = rect.left) <= eLvW &&
						(eLbottom || eLright || eLleft || eLtop) &&
						(lazySizesCfg.loadHidden || isVisible(lazyloadElems[i])) &&
						((isCompleted && isLoading < 3 && !elemExpandVal && (loadMode < 3 || lowRuns < 4)) || isNestedVisible(lazyloadElems[i], elemExpand))){
						unveilElement(lazyloadElems[i]);
						loadedSomething = true;
						if(isLoading > 9){break;}
					} else if(!loadedSomething && isCompleted && !autoLoadElem &&
						isLoading < 4 && lowRuns < 4 && loadMode > 2 &&
						(preloadElems[0] || lazySizesCfg.preloadAfterLoad) &&
						(preloadElems[0] || (!elemExpandVal && ((eLbottom || eLright || eLleft || eLtop) || lazyloadElems[i][_getAttribute](lazySizesCfg.sizesAttr) != 'auto')))){
						autoLoadElem = preloadElems[0] || lazyloadElems[i];
					}
				}

				if(autoLoadElem && !loadedSomething){
					unveilElement(autoLoadElem);
				}
			}
		};

		var throttledCheckElements = throttle(checkElements);

		var switchLoadingClass = function(e){
			var elem = e.target;

			if (elem._lazyCache) {
				delete elem._lazyCache;
				return;
			}

			resetPreloading(e);
			addClass(elem, lazySizesCfg.loadedClass);
			removeClass(elem, lazySizesCfg.loadingClass);
			addRemoveLoadEvents(elem, rafSwitchLoadingClass);
			triggerEvent(elem, 'lazyloaded');
		};
		var rafedSwitchLoadingClass = rAFIt(switchLoadingClass);
		var rafSwitchLoadingClass = function(e){
			rafedSwitchLoadingClass({target: e.target});
		};

		var changeIframeSrc = function(elem, src){
			var loadMode = elem.getAttribute('data-load-mode') || lazySizesCfg.iframeLoadMode;

			// loadMode can be also a string!
			if (loadMode == 0) {
				elem.contentWindow.location.replace(src);
			} else if (loadMode == 1) {
				elem.src = src;
			}
		};

		var handleSources = function(source){
			var customMedia;

			var sourceSrcset = source[_getAttribute](lazySizesCfg.srcsetAttr);

			if( (customMedia = lazySizesCfg.customMedia[source[_getAttribute]('data-media') || source[_getAttribute]('media')]) ){
				source.setAttribute('media', customMedia);
			}

			if(sourceSrcset){
				source.setAttribute('srcset', sourceSrcset);
			}
		};

		var lazyUnveil = rAFIt(function (elem, detail, isAuto, sizes, isImg){
			var src, srcset, parent, isPicture, event, firesLoad;

			if(!(event = triggerEvent(elem, 'lazybeforeunveil', detail)).defaultPrevented){

				if(sizes){
					if(isAuto){
						addClass(elem, lazySizesCfg.autosizesClass);
					} else {
						elem.setAttribute('sizes', sizes);
					}
				}

				srcset = elem[_getAttribute](lazySizesCfg.srcsetAttr);
				src = elem[_getAttribute](lazySizesCfg.srcAttr);

				if(isImg) {
					parent = elem.parentNode;
					isPicture = parent && regPicture.test(parent.nodeName || '');
				}

				firesLoad = detail.firesLoad || (('src' in elem) && (srcset || src || isPicture));

				event = {target: elem};

				addClass(elem, lazySizesCfg.loadingClass);

				if(firesLoad){
					clearTimeout(resetPreloadingTimer);
					resetPreloadingTimer = setTimeout(resetPreloading, 2500);
					addRemoveLoadEvents(elem, rafSwitchLoadingClass, true);
				}

				if(isPicture){
					forEach.call(parent.getElementsByTagName('source'), handleSources);
				}

				if(srcset){
					elem.setAttribute('srcset', srcset);
				} else if(src && !isPicture){
					if(regIframe.test(elem.nodeName)){
						changeIframeSrc(elem, src);
					} else {
						elem.src = src;
					}
				}

				if(isImg && (srcset || isPicture)){
					updatePolyfill(elem, {src: src});
				}
			}

			if(elem._lazyRace){
				delete elem._lazyRace;
			}
			removeClass(elem, lazySizesCfg.lazyClass);

			rAF(function(){
				// Part of this can be removed as soon as this fix is older: https://bugs.chromium.org/p/chromium/issues/detail?id=7731 (2015)
				var isLoaded = elem.complete && elem.naturalWidth > 1;

				if( !firesLoad || isLoaded){
					if (isLoaded) {
						addClass(elem, lazySizesCfg.fastLoadedClass);
					}
					switchLoadingClass(event);
					elem._lazyCache = true;
					setTimeout(function(){
						if ('_lazyCache' in elem) {
							delete elem._lazyCache;
						}
					}, 9);
				}
				if (elem.loading == 'lazy') {
					isLoading--;
				}
			}, true);
		});

		/**
		 *
		 * @param elem { Element }
		 */
		var unveilElement = function (elem){
			if (elem._lazyRace) {return;}
			var detail;

			var isImg = regImg.test(elem.nodeName);

			//allow using sizes="auto", but don't use. it's invalid. Use data-sizes="auto" or a valid value for sizes instead (i.e.: sizes="80vw")
			var sizes = isImg && (elem[_getAttribute](lazySizesCfg.sizesAttr) || elem[_getAttribute]('sizes'));
			var isAuto = sizes == 'auto';

			if( (isAuto || !isCompleted) && isImg && (elem[_getAttribute]('src') || elem.srcset) && !elem.complete && !hasClass(elem, lazySizesCfg.errorClass) && hasClass(elem, lazySizesCfg.lazyClass)){return;}

			detail = triggerEvent(elem, 'lazyunveilread').detail;

			if(isAuto){
				 autoSizer.updateElem(elem, true, elem.offsetWidth);
			}

			elem._lazyRace = true;
			isLoading++;

			lazyUnveil(elem, detail, isAuto, sizes, isImg);
		};

		var afterScroll = debounce(function(){
			lazySizesCfg.loadMode = 3;
			throttledCheckElements();
		});

		var altLoadmodeScrollListner = function(){
			if(lazySizesCfg.loadMode == 3){
				lazySizesCfg.loadMode = 2;
			}
			afterScroll();
		};

		var onload = function(){
			if(isCompleted){return;}
			if(Date.now() - started < 999){
				setTimeout(onload, 999);
				return;
			}


			isCompleted = true;

			lazySizesCfg.loadMode = 3;

			throttledCheckElements();

			addEventListener('scroll', altLoadmodeScrollListner, true);
		};

		return {
			_: function(){
				started = Date.now();

				lazysizes.elements = document.getElementsByClassName(lazySizesCfg.lazyClass);
				preloadElems = document.getElementsByClassName(lazySizesCfg.lazyClass + ' ' + lazySizesCfg.preloadClass);

				addEventListener('scroll', throttledCheckElements, true);

				addEventListener('resize', throttledCheckElements, true);

				addEventListener('pageshow', function (e) {
					if (e.persisted) {
						var loadingElements = document.querySelectorAll('.' + lazySizesCfg.loadingClass);

						if (loadingElements.length && loadingElements.forEach) {
							requestAnimationFrame(function () {
								loadingElements.forEach( function (img) {
									if (img.complete) {
										unveilElement(img);
									}
								});
							});
						}
					}
				});

				if(window.MutationObserver){
					new MutationObserver( throttledCheckElements ).observe( docElem, {childList: true, subtree: true, attributes: true} );
				} else {
					docElem[_addEventListener]('DOMNodeInserted', throttledCheckElements, true);
					docElem[_addEventListener]('DOMAttrModified', throttledCheckElements, true);
					setInterval(throttledCheckElements, 999);
				}

				addEventListener('hashchange', throttledCheckElements, true);

				//, 'fullscreenchange'
				['focus', 'mouseover', 'click', 'load', 'transitionend', 'animationend'].forEach(function(name){
					document[_addEventListener](name, throttledCheckElements, true);
				});

				if((/d$|^c/.test(document.readyState))){
					onload();
				} else {
					addEventListener('load', onload);
					document[_addEventListener]('DOMContentLoaded', throttledCheckElements);
					setTimeout(onload, 20000);
				}

				if(lazysizes.elements.length){
					checkElements();
					rAF._lsFlush();
				} else {
					throttledCheckElements();
				}
			},
			checkElems: throttledCheckElements,
			unveil: unveilElement,
			_aLSL: altLoadmodeScrollListner,
		};
	})();


	var autoSizer = (function(){
		var autosizesElems;

		var sizeElement = rAFIt(function(elem, parent, event, width){
			var sources, i, len;
			elem._lazysizesWidth = width;
			width += 'px';

			elem.setAttribute('sizes', width);

			if(regPicture.test(parent.nodeName || '')){
				sources = parent.getElementsByTagName('source');
				for(i = 0, len = sources.length; i < len; i++){
					sources[i].setAttribute('sizes', width);
				}
			}

			if(!event.detail.dataAttr){
				updatePolyfill(elem, event.detail);
			}
		});
		/**
		 *
		 * @param elem {Element}
		 * @param dataAttr
		 * @param [width] { number }
		 */
		var getSizeElement = function (elem, dataAttr, width){
			var event;
			var parent = elem.parentNode;

			if(parent){
				width = getWidth(elem, parent, width);
				event = triggerEvent(elem, 'lazybeforesizes', {width: width, dataAttr: !!dataAttr});

				if(!event.defaultPrevented){
					width = event.detail.width;

					if(width && width !== elem._lazysizesWidth){
						sizeElement(elem, parent, event, width);
					}
				}
			}
		};

		var updateElementsSizes = function(){
			var i;
			var len = autosizesElems.length;
			if(len){
				i = 0;

				for(; i < len; i++){
					getSizeElement(autosizesElems[i]);
				}
			}
		};

		var debouncedUpdateElementsSizes = debounce(updateElementsSizes);

		return {
			_: function(){
				autosizesElems = document.getElementsByClassName(lazySizesCfg.autosizesClass);
				addEventListener('resize', debouncedUpdateElementsSizes);
			},
			checkElems: debouncedUpdateElementsSizes,
			updateElem: getSizeElement
		};
	})();

	var init = function(){
		if(!init.i && document.getElementsByClassName){
			init.i = true;
			autoSizer._();
			loader._();
		}
	};

	setTimeout(function(){
		if(lazySizesCfg.init){
			init();
		}
	});

	lazysizes = {
		/**
		 * @type { LazySizesConfigPartial }
		 */
		cfg: lazySizesCfg,
		autoSizer: autoSizer,
		loader: loader,
		init: init,
		uP: updatePolyfill,
		aC: addClass,
		rC: removeClass,
		hC: hasClass,
		fire: triggerEvent,
		gW: getWidth,
		rAF: rAF,
	};

	return lazysizes;
}
));


/***/ }),

/***/ "./src/assets/scss/theme.scss":
/*!************************************!*\
  !*** ./src/assets/scss/theme.scss ***!
  \************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"/assets/theme": 0,
/******/ 			"assets/theme": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkydm_starter_theme"] = self["webpackChunkydm_starter_theme"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	__webpack_require__.O(undefined, ["assets/theme"], () => (__webpack_require__("./src/assets/js/theme.js")))
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["assets/theme"], () => (__webpack_require__("./src/assets/scss/theme.scss")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;